import { CdkStepper, CdkStepperModule } from '@angular/cdk/stepper';
import { AsyncPipe, JsonPipe, Location, NgTemplateOutlet } from '@angular/common';
import { AfterViewInit, Component, HostListener, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators, ValidatorFn } from '@angular/forms';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatTooltipModule } from '@angular/material/tooltip';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { UntilDestroy } from '@ngneat/until-destroy';
import {
  ApplicationTypes,
  AbnComponentValue,
  AcnComponentValue,
  Address2ComponentValue,
  AggregatorSearchComponentValue,
  AppCalculator,
  ApplicationApplicant,
  AssetConditionValue,
  AssetFinanceApplication,
  AssetFinanceProductType,
  AssetFinanceSummary,
  LoanPurposeValue,
  AssetSelectionComponentValue,
  AzureStorageDocument,
  UploadedDocumentRef,
  BalloonPaymentValue,
  BalloonPaymentValueOptions,
  Base64File,
  booleanToYesNo,
  BrokerageSelectionValue, BrokerOfUser, BusinessNumberSearchValue,
  BusinessSearchValue,
  calculateAssetFinanceEstimation,
  CommercialEntity,
  constants,
  CurrencyInputValue,
  defaultDocuments,
  DirectorValue,
  DocumentTag,
  EntityTypeCompanyOption,
  EntityTypeOtherOption,
  EntityTypePartnershipOption,
  EntityTypes,
  EntityTypeSoleTraderOption,
  EntityTypeTrustOption,
  EntityTypeValue,
  filesToBase64Files,
  FinanceTypeValue,
  FinanceTypeValueOptions,
  GeoLocation,
  GetSalesforceContactSameAccountFunc,
  GetUserSameCompanyFunc,
  GuarantorValue,
  GuarantorKybSelectionsEvent,
  IndividualGuarantor,
  isAddressEquals,
  isApplicationApplicantIndividual,
  isApplicationApplicantsSoleTrader,
  isAssetNewCars,
  isAssetTrucksOrTrailers,
  isAssetTypeLightOrHeavyTruck,
  isAssetVehicles,
  isExternalUser,
  LoanTermsSelectionWithInputValue,
  maxLoanForAssetFinance,
  MemberValue,
  minDepositForAssetFinance,
  NotNullable,
  OriginatorBusiness,
  PartnerValue,
  patchAcn,
  PaymentFrequencyValue,
  PaymentFrequencyValueOptions,
  PlacesDetailsFn,
  PlacesSearchResultFn,
  PrimaryIndustrySelectionValue,
  PrivateSaleType,
  RatecardDetails,
  ReferenceValue,
  SalesforceContactSameAccountSelectionValue,
  SaveApplicationPricingDetailsData,
  SecondaryIndustrySelectionValue,
  SubdivisionIndustrySelectionValue,
  SelectContactValue,
  SoleTraderValue,
  TermRate,
  toDraftSimplifiedApplication,
  TotalPaymentBreakupDialogData,
  TransactionValue,
  TrusteeValue,
  UpdateApplicationData,
  WizardSubmitData,
  UploadAzureFiles,
  RequiredTrustDeed,
  UploadAzureFilesValue,
  UploadFileValue, User,
  UserSameCompanySelectionValue,
  UserSelectionValue,
  YesNoValue,
  assetFinanceEquifaxDirectorScoreThreshold,
  GetIndustryDivisionsFn,
  GetIndustryGroupsByDivisionCodeFn,
  GetIndustryClassesByGroupCodeFn,
  GetIndustryDivisionTitleFn,
  GetIndustryGroupTitleFn,
  GetIndustryClassTitleFn,
  convertStringToBoolean,
  validateEOTAge,
  getMaxLoanTermForTier,
  getTreasuryAssetCondition,
  isTransactionTypeAllowedForNewAsset,
  getAllowedTransactionTypesForNewAsset,
  isInternalUser,
  KybRefreshFn,
  KybResultFn,
  KybSetManualModeFn,
  KybInitiateCorporatePartyFn,
  KybResult,
  kybHasOwnKeyPeople,
  KybKeyPeopleValue,
  KYB_KEY_PEOPLE_STEP_VALIDATION_MESSAGE,
  IndividualDetailsListValue,
  BORROWING_ENTITY_LOCKED_HINT,
  ApplicationCommercialEntityWrite,
  ASSET_FINANCE_MAX_BROKERAGE_PERCENT,
} from '@portal-workspace/grow-shared-library';
import {
  AbnComponent, AcnComponent, AggregatorSearchComponent, AggregatorSearchFn, AnnualRevenueComponent, AnnualRevenueValue,
  applicantsThatAreGuarantor,
  ApplicationDialogService, ApplicationHeaderSegmentComponent, ApplicationStepper2Component, ApplicationStepperComponent, applicationToAbn,
  applicationToAcn,
  applicationToAdditionalBrokerCorrespondent,
  applicationToAdverseOnFile,
  applicationToApplicants,
  applicationToApplicationNotes,
  applicationToAsset,
  applicationToAssetCondition,
  applicationToBalloonPaymentPrecentage,
  applicationToBrokerage,
  applicationToBrokerContact,
  applicationToBrokerFlowDocumentId,
  applicationToBrokerOriginationFee,
  applicationToBrokerSearchValue,
  applicationToBusinessSearchValue,
  applicationToDepositAmount,
  applicationToDocFeeFinanced,
  applicationToEquifaxDirectorScoreMeetsThreshold,
  linkEquifaxDirectorScoreControls,
  applicationToFinanceType,
  applicationToGuarantors,
  applicationToHasAdditionalBrokerCorrespondent,
  applicationToIndustrySector,
  applicationToInvoiceAmount,
  applicationToLegalName,
  applicationToLoanAmount,
  applicationToLoanTermsValue,
  applicationToOrganisationType,
  applicationToPaymentFrequency,
  applicationToPreviousBusiness,
  applicationToPrimaryAddress,
  applicationToRegisteredBusinessAddress,
  applicationToPrimaryIndustry,
  applicationToPropertyOwner,
  applicationToReferences,
  applicationToRevenue,
  applicationToTransactionValue, ASSET_FINANCE_OPTIONS_FILTER, AssetConditionComponent, AssetFinanceSummaryComponent, AssetSelectionComponent, AssetSelectionComponentSearchFn, BalloonPaymentComponent, BrokerageSelectionComponent, BusinessNumberSearchComponent, BusinessNumberSearchFn, BusinessSearchComponent, BusinessSearchFn, CurrencyInputComponent, CustomAddressComponent, DirectorComponent, DisableControlDirective, duplicateFileNameValidator, EntityTypeComponent, FinanceTypeSelectionComponent, formControlErrorKeys,
  formControlErrorMessage,
  fromApplicantToInteflowCommercialEntities,
  fromApplicantToInteflowIndividualsData,
  fromContactToInteflowContacts,
  fromGuarantorToInteflowCommercialEnttities,
  fromGuarantorToInteflowIndividuals,
  fromReferenceToInteflowReferences,
  getUser, GuarantorComponent, GuarantorComponentEvent, mergeGuarantorKybSelections, guarantorEntityValidator, applicantEntityNotPrimaryValidator, previousBusinessNotPrimaryValidator, individualGarantors, collectIndividualIdDocumentUploads, tagIndividualIdDocumentFiles, LoanPurposeSelectionComponent, LoanTermsSelectionComponent, LoanTermsSelectionWithInputComponent, MarkDirective, MemberComponent, MessageBoxComponent, MobileComponent, PartnerComponent, partnerValidator, PaymentFrequencySelectionComponent, PortalHotToastService, PrimaryIndustrySelectionComponent, ReferenceComponent, requiredAllowEmptyValidator, SalesforceContactSameAccountSelectionComponent, SecondaryIndustrySelectionComponent, SubdivisionIndustrySelectionComponent, setStepper2StepConfig,
  setupUntilDestroy, SoleTraderComponent, toApiAddress,
  KybKeyPeopleComponent,
  KybStatusComponent,
  IndividualDetailsListComponent,
  consentAcknowledgementIndividuals,
  mergeSavedIndividualsIntoInteflowIndividuals,
  savedIndividualsToPrimaryContact,
  savedIndividualsToContacts,
  toInteflowEntityTypes,
  toInteflowLegalName, TransactionTypeSelectionComponent, TrusteeComponent, trusteeValidator, TrustDeedUploadComponent, UploadedFilesListComponent, UploadedFilesListComponentEvent, UploadFileComponent, UploadFilesMultiTagsComponent, UserSameCompanySelectionComponent, UserSelectionComponent, YesNoComponent,
  applicationToSubdivisionIndustrySector,
  calculateAbnAgeOverrideFromPreviousBusiness,
  searchResultToGstAgeMonths,
  searchResultToGstAgeMonthsWithContinuity
} from '@portal-workspace/grow-ui-library';
import _ from 'lodash';
import moment, { Moment } from 'moment';
import numeral from 'numeral';
import { catchError, combineLatest, from, lastValueFrom, Observable, of, Subscription } from 'rxjs';
import { filter, map, startWith, switchMap, tap } from 'rxjs/operators';
import { environment } from '../../../environments/environment';
import { AdminService } from '../../service/admin.service';
import { ApplicationService, } from '../../service/application.service';
import { AuthService } from '../../service/auth.service';
import { DigitalIdService } from '../../service/digital-id.service';
import { LocalApplicationsDbService } from "../../service/local-applications-db.service";
import { IndustryService } from '../../service/industry.service';
import {
  navigationUrlForApplicationsWithQueryParams, navigationUrlForAssetFinance, navigationUrlForAssetProductSelectorWithQueryParams,
} from '../../service/navigation-urls';
import { RedbookService } from '../../service/redbook.service';

export type DriverLicenceUpload = {id: string, name: string, formControl: FormControl<UploadFileValue>};
export type DriverLicenceUpload2 = {id: string, name: string, description: string, formControl: FormControl<UploadFileValue>};

// NOTE: Page to land when you are in DRAFT (new unsubmitted) asset application
@UntilDestroy({arrayName: 'subscriptions'})
@Component({
    templateUrl: './asset-finance.page.html',
    styleUrls: ['./asset-finance.page.scss'],
    standalone: true,
    imports: [
      ApplicationStepperComponent,
      CdkStepperModule,
      NgTemplateOutlet,
      FormsModule,
      ReactiveFormsModule,
      BusinessSearchComponent,
      MarkDirective,
      MatCheckboxModule,
      MatTooltipModule,
      UserSelectionComponent,
      AggregatorSearchComponent,
      CurrencyInputComponent,
      AssetSelectionComponent,
      AssetConditionComponent,
      YesNoComponent,
      LoanTermsSelectionComponent,
      PaymentFrequencySelectionComponent,
      DisableControlDirective,
      FinanceTypeSelectionComponent,
      BalloonPaymentComponent,
      BrokerageSelectionComponent,
      ApplicationHeaderSegmentComponent,
      EntityTypeComponent,
      AbnComponent,
      AcnComponent,
      AnnualRevenueComponent,
      PrimaryIndustrySelectionComponent,
      SecondaryIndustrySelectionComponent,
      SubdivisionIndustrySelectionComponent,
      CustomAddressComponent,
      MobileComponent,
      TrusteeComponent,
      SoleTraderComponent,
      PartnerComponent,
      DirectorComponent,
      MemberComponent,
      GuarantorComponent,
      KybKeyPeopleComponent,
      KybStatusComponent,
      IndividualDetailsListComponent,
      MatFormFieldModule,
      MatInputModule,
      ReferenceComponent,
      MessageBoxComponent,
      TrustDeedUploadComponent,
      UploadedFilesListComponent,
      UploadFileComponent,
      UploadFilesMultiTagsComponent,
      AssetFinanceSummaryComponent,
      BusinessNumberSearchComponent,
      TransactionTypeSelectionComponent,
      UserSameCompanySelectionComponent,
      SalesforceContactSameAccountSelectionComponent,
      JsonPipe,
      LoanPurposeSelectionComponent,
      AsyncPipe,
      ApplicationStepper2Component,
      LoanTermsSelectionWithInputComponent,
    ],
})
export class AssetFinancePage implements OnInit, AfterViewInit {
  
  // Helper method for template
  parseAssetYear(year: string | null | undefined): number | null {
    return year ? parseInt(year) : null;
  }

  @HostListener( 'window: popstate', ['$event'])
    async onPopState(event: Event): Promise<void> {
      event.preventDefault();
      await this.router.navigateByUrl(navigationUrlForApplicationsWithQueryParams(this.router, this.queryParams));
    }

  ASSET_FINANCE_OPTIONS_FILTER = ASSET_FINANCE_OPTIONS_FILTER;
  ASSET_FINANCE_MAX_BROKERAGE_PERCENT = ASSET_FINANCE_MAX_BROKERAGE_PERCENT;
  placesSearchResultFn!: PlacesSearchResultFn;
  placesDetailsFn!: PlacesDetailsFn;
  getIndustryDivisionsFn!: GetIndustryDivisionsFn;
  getIndustryGroupsByDivisionCodeFn!: GetIndustryGroupsByDivisionCodeFn;
  getIndustryClassesByGroupCodeFn!: GetIndustryClassesByGroupCodeFn;
  getIndustryDivisionTitleFn!: GetIndustryDivisionTitleFn;
  getIndustryGroupTitleFn!: GetIndustryGroupTitleFn;
  getIndustryClassTitleFn!: GetIndustryClassTitleFn;

  businessSearchPlaceholder:string="Enter name or ABN…"   

  MIN_LOAN_AMOUNT = 0.01;

  step2MaxLimit = 150000
  step2MinLimit = 2000

  MIN_ORIGINATION_FEE = 0;
  MAX_ORIGINATION_FEE = 900;

  existingApplication: AssetFinanceApplication | null = null; // editing an existing application
  existingApplicationBureauReport: AssetFinanceApplication['CompanyDetails'] | null = null;
  rateCard: RatecardDetails | null = null;

  errorKeys = formControlErrorKeys;
  errorMessages = formControlErrorMessage;
  @ViewChild('balloonPaymentComponent') balloonPaymentComponent!: BalloonPaymentComponent;
  @ViewChild('uploadFilesMultiTagsComponent') uploadFilesMultiTagsComponent!: UploadFilesMultiTagsComponent;
  @ViewChild(LoanPurposeSelectionComponent) loanPurposeComponent!: LoanPurposeSelectionComponent;
  @ViewChild('assetConditionComponent') assetConditionComponent!: AssetConditionComponent;

  ip: string = '';
  geoLocation: GeoLocation = {};
  user: User = getUser()!;
  otherUsersObservable?: Observable<NotNullable<UserSelectionValue>[]>;
  brokerOfUser: BrokerOfUser | null = null;
  acceptedQuotation = false;
  brokerApplicationId: string | null = null;
  applicationId: number | null = null;
  isExternalUser : boolean = isExternalUser(this.user);
  AmountFinance!: number;
  isVendorUser: boolean = false; // New property to determine if the user is a vendor
  organisationName: string = 'Not available';
  terms: TermRate | null = null;          // available after chart popups
  calculator: AppCalculator | null = null;   // available after chart popups
  businessUseOnly = false;
  selfServiceability = false;
  subscriptions: Subscription[] = [];
  defaultDocuments = defaultDocuments;
  step1SearchFn!: BusinessSearchFn;
  step1GetUserSameCompanyFn!: GetUserSameCompanyFunc;
  step1GetSalesforceContactSameAccountFn!: GetSalesforceContactSameAccountFunc;
  step1BrokerSearchFn!: AggregatorSearchFn;
  step1OrgSalesforceId: string | null = null;
  step1NoOtherUsersInCompany = true;
  formControlStep1Broker!: FormControl<AggregatorSearchComponentValue>;
  formGroupStep1!: FormGroup<{
    broker: FormControl<AggregatorSearchComponentValue>,
    business: FormControl<BusinessSearchValue>,
    showCorrespondent: FormControl<boolean | null>,
    correspondent: FormControl<UserSelectionValue>,
    previousBusiness: FormControl<BusinessNumberSearchValue>,
    brokerContact:FormControl<SalesforceContactSameAccountSelectionValue>
  }>;
  formControlStep1Business!: FormControl<BusinessSearchValue>;
  formControlStep1ShowCorrespondent!: FormControl<boolean | null>;
  formControlStep1Correspondent!: FormControl<UserSameCompanySelectionValue>;
  formControlStep1BrokerContact!: FormControl<SalesforceContactSameAccountSelectionValue>;
  formControlStep1PreviousBusiness!: FormControl<BusinessNumberSearchValue>;

  // ADO-1295: the borrowing entity (and previous business) lock once the broker moves off the
  // application step, so the company check and key-people selections stay anchored to the chosen
  // entity. An application id exists only after that step has been saved, which also covers a
  // reopened draft.
  get borrowingEntityLocked(): boolean {
    return !!this.applicationId;
  }

  get step1BusinessLockedHint(): string | null {
    return this.borrowingEntityLocked ? BORROWING_ENTITY_LOCKED_HINT : null;
  }

  /** GST age that treats a cancelled registration as 0, unlike result.GSTAgeMonths. */
  get step1GstAgeMonths(): number {
    const v = this.formControlStep1Business?.value;
    if (!v || v.type !== 'search-result') return 0;
    return searchResultToGstAgeMonths(v.result, 0);
  }
  
  // step 2:
  step2AssetCategoryIndexFilter = ['130', '137', '132', '133', '134', '135', '136', '106', '140', '142'];
  step2MinBrokerOriginationFee = this.MIN_ORIGINATION_FEE ;
  step2MaxBrokerOriginationFee = this.MAX_ORIGINATION_FEE ;
  step2DepositMin: number | null = null;
  step2DepositMax: number | null = null;
  formGroupStep2!: FormGroup<{
    invoiceAmount: FormControl<CurrencyInputValue>,
    depositAmount: FormControl<CurrencyInputValue>,
    loanAmount: FormControl<CurrencyInputValue>,
    asset: FormControl<AssetSelectionComponentValue>,
    assetCondition: FormControl<AssetConditionValue>,
    loanTerms: FormControl<LoanTermsSelectionWithInputValue>,
    paymentFrequency: FormControl<PaymentFrequencyValue>,
    financeType: FormControl<FinanceTypeValue>,
    docFeeFinanced: FormControl<YesNoValue>,
    balloonPayment: FormControl<BalloonPaymentValue>,
    brokerOriginationFee: FormControl<CurrencyInputValue>,
    brokerage: FormControl<BrokerageSelectionValue>,
    propertyOwner: FormControl<YesNoValue>,
    adverseOnFile: FormControl<YesNoValue>,
    equifaxScoreAboveThreshold: FormControl<YesNoValue>,
    equifaxDirectorScoreAbove700: FormControl<YesNoValue>,
    transactionType: FormControl<TransactionValue>,
    assetPurpose: FormControl<LoanPurposeValue>,
  }>;
  formControlStep2InvoiceAmount!: FormControl<CurrencyInputValue>;
  formControlStep2DepositAmount!: FormControl<CurrencyInputValue>;
  formControlStep2LoanAmount!: FormControl<CurrencyInputValue>;
  formControlStep2Asset!: FormControl<AssetSelectionComponentValue>;
  step2AssetSearchFn!: AssetSelectionComponentSearchFn;
  formControlStep2AssetCondition!: FormControl<AssetConditionValue>;
  formControlStep2LoanTerms!: FormControl<LoanTermsSelectionWithInputValue>;
  formControlStep2PaymentFrequency!: FormControl<PaymentFrequencyValue>;
  formControlStep2FinanceType!: FormControl<FinanceTypeValue>;
  formControlStep2DocFeeFinanced!: FormControl<YesNoValue>;
  formControlStep2BalloonPayment!: FormControl<BalloonPaymentValue>;
  formControlStep2BrokerOriginationFee!: FormControl<CurrencyInputValue>;
  formControlStep2Brokerage!: FormControl<BrokerageSelectionValue>;
  formControlStep2TransactionType!: FormControl<TransactionValue>;
  formControlStep2AssetPurpose!: FormControl<LoanPurposeValue>;
  brokerageSelectionTitle = 'Brokerage'; // New property for the title
  step2MaxLoanTerm: number = 84;

  formControlStep2PropertyOwner!: FormControl<YesNoValue>;
  formControlStep2AdverseOnFile!: FormControl<YesNoValue>;
  formControlStep2EquifaxScoreAboveThreshold!: FormControl<YesNoValue>;
  formControlStep2EquifaxDirectorScoreAbove700!: FormControl<YesNoValue>;
  step2Repayment = 0;
  step2EstimatedDrawdownDate: Moment = moment();
  step2Subscription1?: Subscription;
  _showAssetPurpose = false;


  // step 3:
  step3OnwardsOrganisationType: EntityTypes | null = null;
  formGroupStep3!: FormGroup<{
    organisationType: FormControl<EntityTypeValue>,
    abn: FormControl<AbnComponentValue>,
    acn: FormControl<AcnComponentValue>,
    annualRevenue: FormControl<AnnualRevenueValue>,
    primaryIndustry: FormControl<PrimaryIndustrySelectionValue>,
    industrySector: FormControl<SecondaryIndustrySelectionValue>,
    industryClass: FormControl<SubdivisionIndustrySelectionValue>,
    address: FormControl<Address2ComponentValue>,
    registeredBusinessAddress: FormControl<Address2ComponentValue>,
  }>;
  formControlStep3OrganisationType!: FormControl<EntityTypeValue>;
  formControlStep3Abn!: FormControl<AbnComponentValue>;
  formControlStep3Acn!: FormControl<AcnComponentValue>;
  formControlStep3AnnualRevenue!: FormControl<AnnualRevenueValue>;
  formControlStep3PrimaryIndustry!: FormControl<PrimaryIndustrySelectionValue>;
  formControlStep3IndustrySector!: FormControl<SecondaryIndustrySelectionValue>;
  formControlStep3SubdivisionIndustrySector!: FormControl<SubdivisionIndustrySelectionValue>;
  formControlStep3Address!: FormControl<Address2ComponentValue>;
  formControlStep3RegisteredBusinessAddress!: FormControl<Address2ComponentValue>;
  // The company check the step waits on. Held so step 4 can render its key people without a second
  // read, and so a re-entered step shows the form immediately instead of waiting again.
  step3KybResult: KybResult | null = null;
  step3ManualKyb = false;
  // The stepper builds every step's content up front, so the company check must not begin waiting
  // until this step is actually reached.
  step3Active = false;
  step3KybResultFn!: KybResultFn;
  step3KybRefreshFn!: KybRefreshFn;
  kybSetManualModeFn!: KybSetManualModeFn;

  /**
   * Whether the form is still behind the applicant's company check.
   *
   * A trust or partnership is let straight through: its key people are the trustees/partners typed
   * in on step 4, so this step reads nothing from that run. Those brokers enter both addresses by
   * hand, because the registry prefill arrives with the same result.
   */
  get step3AwaitingKyb(): boolean {
    return !this.step3ManualKyb
      && !this.step3KybResult
      && kybHasOwnKeyPeople(this.step3OnwardsOrganisationType);
  }

  // Add property to track division code for secondary industry
  step3PrimaryIndustryDivisionCode: string | null = null;
  step3IndustrySectorGroupCode: string | null = null;

  // step 4:
  step4BusinessSearchFn!: BusinessSearchFn;
  step4BusinessNumberSearchFn!: BusinessNumberSearchFn;
  step4KybResultFn!: KybResultFn;
  step4KybInitiateCorporatePartyFn!: KybInitiateCorporatePartyFn;
  step4KybWarnings: string[] = [];
  // As step3Active: the step is built up front, so its waiting panel must not start before it is
  // reached.
  step4Active = false;
  step4StoredApplicant: ApplicationApplicant | null = null;
  formControlStep4Applicant!: FormControl<ApplicationApplicant>;
  formControlStep4KybKeyPeople!: FormControl<KybKeyPeopleValue | null>;
  formGroupStep4!: FormGroup<{
    applicant: FormControl<ApplicationApplicant>,
    kybKeyPeople: FormControl<KybKeyPeopleValue | null>,
  }>;

  // step 5:
  step5CompanySearchFn!: BusinessSearchFn;
  step5BusinessNumberSearchFn!: BusinessNumberSearchFn;
  // Ticks made against an additional guarantor entity's key people. Merged into the Key People
  // payload on save, which is a full sync and would otherwise deselect them.
  step5KybSelections: GuarantorKybSelectionsEvent | null = null;
  step5KybWarnings: string[] = [];
  formControlStep5Guarantors!: FormControl<GuarantorValue>;
  formGroupStep5!: FormGroup<{
    guarantors: FormControl<GuarantorValue>
  }>;

  // step 6: individual details review (also where the primary contact is chosen)
  formControlStep6IndividualDetails!: FormControl<IndividualDetailsListValue>;
  formGroupStep6!: FormGroup<{
    individualDetails: FormControl<IndividualDetailsListValue>,
  }>;
  @ViewChild('individualDetailsListComponent') individualDetailsListComponent?: IndividualDetailsListComponent;
  @ViewChild(KybKeyPeopleComponent) kybKeyPeopleComponent?: KybKeyPeopleComponent;
  @ViewChild(GuarantorComponent) guarantorComponent?: GuarantorComponent;

  // step 7:
  formControlStep7BrokerflowDocumentId!: FormControl<string | null>;
  formControlStep7References!: FormControl<ReferenceValue>;
  formGroupStep7!: FormGroup<{
    brokerflowDocumentId: FormControl<string | null>,
    references: FormControl<ReferenceValue>,
  }>;

  step9UploadedDocs: AzureStorageDocument[] = [];
  applicationDocuments: AzureStorageDocument[] | null = null;
  step4DeletedIdDocuments: UploadedDocumentRef[] = [];
  step5DeletedIdDocuments: UploadedDocumentRef[] = [];
  step9DeletedUploadedDocs: Exclude<AzureStorageDocument[], null> = [];
  filesUploadedToAzure: Base64File[] = [];

  // step 8: trust deeds. Derived here rather than inside the step so the stepper can leave the step
  // out entirely when the application needs no deed.
  requiredTrustDeeds: RequiredTrustDeed[] = [];
  step8DeletedUploadedDocs: Exclude<AzureStorageDocument[], null> = [];
  formControlStep8TrustDeeds!: FormControl<UploadAzureFilesValue>;
  formGroupStep8!: FormGroup<{
    trustDeeds: FormControl<UploadAzureFilesValue>,
  }>;

  // step 9:
  formControlStep9OtherSupportingDocuments!: FormControl<UploadAzureFilesValue>;
  formGroupStep9!: FormGroup<{
    otherSupportingDocuments: FormControl<UploadAzureFilesValue>,
  }>;

  // step 10:
  formControlStep10ApplicationNotes!: FormControl<string | null>;
  formGroupStep10!: FormGroup<{
    applicationNotes: FormControl<string | null>,
  }>;

  // step 11:
  formGroupStep11!: FormGroup<{}>;
  step11Summary!: AssetFinanceSummary;

  showAddressFormFlag = true;
  documentTypes: DocumentTag[] = [];
  productType!: AssetFinanceProductType;
  isSwitchToEasyDoc!: boolean;

  queryParams: Params = {};

  applicationType: ApplicationTypes = 'AssetFinance'; // Set default or get from data/queryParams
  
  constructor(private formBuilder: FormBuilder,
              private redbookService: RedbookService,
              private toastService: PortalHotToastService,
              private applicationService: ApplicationService,
              private applicationDialogService: ApplicationDialogService,
              private localApplicationDbService: LocalApplicationsDbService,
              private adminService: AdminService,
              private router: Router,
              private route: ActivatedRoute,
              private location: Location,
              private authService: AuthService,
              private digitalIdService: DigitalIdService,
              private industryService: IndustryService) 
  {
    this.placesSearchResultFn = this.authService.getGooglePlacesSearchResultFn;
    this.placesDetailsFn = this.authService.getGooglePlacesDetailsFn;
    this.getIndustryDivisionsFn = this.industryService.getIndustryDivisionsFn;
    this.getIndustryGroupsByDivisionCodeFn = this.industryService.getIndustryGroupsByDivisionCodeFn;
    this.getIndustryClassesByGroupCodeFn = this.industryService.getIndustryClassesByGroupCodeFn;
    this.getIndustryDivisionTitleFn = this.industryService.getIndustryDivisionTitleFn;
    this.getIndustryGroupTitleFn = this.industryService.getIndustryGroupTitleFn;
    this.getIndustryClassTitleFn = this.industryService.getIndustryClassTitleFn;
  }
  async ngOnInit() {
    setupUntilDestroy(this);
    this.queryParams = this.route.snapshot.queryParams ?? {};
    this.existingApplication = (this.route.snapshot.data as any).application;
    this.rateCard = (this.route.snapshot.data as any).ratecard;
    this.productType = this.queryParams.productType ?? 'EASY DOC';
    this.isSwitchToEasyDoc = convertStringToBoolean(this.queryParams.isSwitchToEasyDoc)
    console.log(`Resolved [AssetFinance] application, productType=${this.productType}, isSwitchToEasyDoc=${this.isSwitchToEasyDoc}`, this.existingApplication);
    if (this.existingApplication) {
      if (this.existingApplication.ApplicationType != 'AssetFinance') {
        this.toastService.error(`This application ${this.existingApplication.ApplicationId} is not an Asset Finance application`, `Invalid application type`);
      }
    }


    this.initStep1();
    this.initStep2();
    this.initStep3();
    this.initStep4();
    this.initStep5();
    this.initStep6();
    this.initStep7();
    this.initStep8();
    this.initStep9();
    this.initStep10();
    this.initStep11();
    this.populate();


    // get ip
    const sub1 = this.applicationService.getIpAddress().pipe(
      map(r => {
        if (r.status) {
          this.ip = r.payload;
        }
      })
    ).subscribe();
    this.subscriptions.push(sub1);

    // get geolocation
    try {
      const geoLocation = await this.applicationService.getGeoLocation();
      if (geoLocation) {
        this.geoLocation = geoLocation;
      }
    } catch(err) {
      console.log(err);
    }


    // get broker of user
    const sub2 = this.applicationService.getBrokerOfUser(this.user.UserId).pipe(
      tap(r => {
        if (r.status) {
          this.brokerOfUser = r.payload;
        }
      })
    ).subscribe();
    this.subscriptions.push(sub2);

     

    // pop up rental excl gst notification
    const sub3 = this.formControlStep2FinanceType.valueChanges.pipe(
      tap((financeType: FinanceTypeValue) => {
        if (financeType?.type === 'rental') {
          this.formControlStep2PaymentFrequency.disable();
          this.formControlStep2PaymentFrequency.setValue(PaymentFrequencyValueOptions[2]/*monthly*/);
        } else if (financeType?.type === 'chattel-mortgage') {
          this.formControlStep2PaymentFrequency.enable();
        }
      })
    ).subscribe();

    if (this.formControlStep2FinanceType.value?.type === 'chattel-mortgage'){
      this.formControlStep2PaymentFrequency.enable();
    } else{
      this.formControlStep2PaymentFrequency.disable();
      this.formControlStep2PaymentFrequency.setValue(PaymentFrequencyValueOptions[2]/*monthly*/);
    }
  }

  ngAfterViewInit(): void {
    const sub2= combineLatest([
      this.formControlStep2Asset.valueChanges,
      this.formControlStep2LoanTerms.valueChanges
    ]).pipe(
      tap((r: [AssetSelectionComponentValue, LoanTermsSelectionWithInputValue]) => {
        const assetSelectionValue = r[0];
        const loanTermValue = r[1];
        this.step2UpdateBalloonPaymentValidation(assetSelectionValue, loanTermValue);
      })
    ).subscribe();
    this.subscriptions.push(sub2);
    if (this.existingApplication) {
      setTimeout(()=> {
        this.step2UpdateBalloonPaymentValidation(this.formControlStep2Asset.value, this.formControlStep2LoanTerms.value);
        const asset = this.formControlStep2Asset.value;
        if (asset && asset.category && asset.category.index) {
          this.step2MaxLoanTerm = getMaxLoanTermForTier(asset.category.index);
        }
      }, 2000);
    }
  }

  step2UpdateBalloonPaymentValidation(assetSelectionValue: AssetSelectionComponentValue, loanTermValue: LoanTermsSelectionWithInputValue) {
    if (assetSelectionValue && assetSelectionValue.category && assetSelectionValue.year && loanTermValue && this.balloonPaymentComponent) {
      const assetCatgory = assetSelectionValue.category.index;
      const loanTerm = loanTermValue;
      const assetYear = parseInt(assetSelectionValue.year);
      const maxRv = new AppCalculator().getMaxRV(assetCatgory, loanTerm, assetYear);
      // Balloon amount (balloon % x invoice) must not exceed the loan amount (invoice - deposit)
      this.balloonPaymentComponent.setMaxRv(Math.min(maxRv, this.step2GetLoanAmountMaxBalloonPercentage()));
    }
  }

  // Maximum balloon/residual percentage allowed so the balloon amount does not
  // exceed the loan amount (Invoice - Deposit). Returns 100 (no constraint) when
  // the invoice amount is not yet known.
  step2GetLoanAmountMaxBalloonPercentage(): number {
    const invoiceAmount = this.formControlStep2InvoiceAmount.value ?? 0;
    const depositAmount = this.formControlStep2DepositAmount.value ?? 0;
    if (invoiceAmount <= 0) {
      return 100;
    }
    const loanAmount = Math.max(invoiceAmount - depositAmount, 0);
    return Math.floor(loanAmount / invoiceAmount * 100);
  }

  step2UpdateDepositValidation() {
    const asset: AssetSelectionComponentValue = this.formControlStep2Asset.value;
    if (asset && !asset.invalid) {
      const invoiceAmount = this.formControlStep2InvoiceAmount.value ?? 0;
      const assetCategoryIndex = asset.category.index;
      const isPropetyOwner = this.formControlStep2PropertyOwner.value ?? false;
      const docCriteria = this.productType
      const minDeposit = minDepositForAssetFinance(invoiceAmount, isPropetyOwner, this.productType);
      this.step2DepositMin = minDeposit;
      this.step2DepositMax = _.round(invoiceAmount * 0.8, 2); // 80% of invoiceAmount;

      //this.step2MaxLimit
      this.step2MaxLimit = maxLoanForAssetFinance (assetCategoryIndex, isPropetyOwner,docCriteria)
      console.log("this.step2MaxLimit",this.step2MaxLimit)
      const depositAmount = this.formControlStep2DepositAmount.value ?? 0;
      const financeType = this.formControlStep2FinanceType.value;
      const depositAmountExGST = Math.round(depositAmount * 1000 / 11) / 100;
      const deposit = financeType?.type === 'rental' ? depositAmountExGST : depositAmount;
      const loanAmount = parseFloat((invoiceAmount - deposit > 0) ? (invoiceAmount - deposit).toFixed(2) : '0');
      this.formControlStep2LoanAmount.setValue(loanAmount);
    }
  }

  populate() {
    if (this.existingApplication) {
      // 1
      const businessSearchValue = applicationToBusinessSearchValue(this.existingApplication);
      const previousBusinessValue = applicationToPreviousBusiness(this.existingApplication);

      this.formControlStep1PreviousBusiness.setValue(previousBusinessValue);
      this.formControlStep1Business.setValue(businessSearchValue);
      this.formControlStep1ShowCorrespondent.setValue(applicationToHasAdditionalBrokerCorrespondent(this.existingApplication));
      this.formControlStep1Correspondent.setValue(applicationToAdditionalBrokerCorrespondent(this.existingApplication));
      this.formControlStep1BrokerContact.setValue(applicationToBrokerContact(this.existingApplication));

      this.brokerApplicationId = this.existingApplication.BrokerAppId;
      this.applicationId = this.existingApplication.ApplicationId;
      this.acceptedQuotation = this.existingApplication.AcceptQuotation;
      this.organisationName = applicationToLegalName(this.existingApplication) ?? '';
      const brokerSearchValue = applicationToBrokerSearchValue(this.existingApplication);
      this.formControlStep1Broker.setValue(brokerSearchValue);
      this.step1OrgSalesforceId = brokerSearchValue?.salesforceId ?? null;

      // 2
      this.acceptedQuotation = this.existingApplication.AcceptQuotation;
      this.existingApplicationBureauReport = this.existingApplication.CompanyDetails;
      this.formControlStep2InvoiceAmount.setValue(applicationToInvoiceAmount(this.existingApplication));
      this.formControlStep2DepositAmount.setValue(applicationToDepositAmount(this.existingApplication));
      this.formControlStep2LoanAmount.setValue(applicationToLoanAmount(this.existingApplication));
      this.formControlStep2AssetCondition.setValue(applicationToAssetCondition(this.existingApplication));
      this.formControlStep2TransactionType.setValue(applicationToTransactionValue(this.existingApplication));
      this.formControlStep2LoanTerms.setValue(applicationToLoanTermsValue(this.existingApplication));
      this.formControlStep2PaymentFrequency.setValue(applicationToPaymentFrequency(this.existingApplication) ??
      PaymentFrequencyValueOptions.find(o => o.type === 'Monthly') ?? null);
      this.formControlStep2FinanceType.setValue(applicationToFinanceType(this.existingApplication));
      this.formControlStep2DocFeeFinanced.setValue(applicationToDocFeeFinanced(this.existingApplication));
      this.formControlStep2BalloonPayment.setValue(applicationToBalloonPaymentPrecentage(this.existingApplication));
      this.formControlStep2BrokerOriginationFee.setValue(applicationToBrokerOriginationFee(this.existingApplication));
      this.formControlStep2Brokerage.setValue(applicationToBrokerage(this.existingApplication));
      this.formControlStep2PropertyOwner.setValue(applicationToPropertyOwner(this.existingApplication));
      this.formControlStep2AdverseOnFile.setValue(applicationToAdverseOnFile(this.existingApplication));
      this.formControlStep2EquifaxScoreAboveThreshold.setValue(applicationToEquifaxDirectorScoreMeetsThreshold(this.existingApplication, '>=550'));
      this.formControlStep2EquifaxDirectorScoreAbove700.setValue(applicationToEquifaxDirectorScoreMeetsThreshold(this.existingApplication, '>=700'));
      this.formControlStep2Asset.setValue(applicationToAsset(this.existingApplication));
      this.formControlStep2AssetPurpose.setValue(this.existingApplication.AppInfo.LoanPurpose);


      // 3
      this.formControlStep3OrganisationType.setValue(applicationToOrganisationType(this.existingApplication));
      this.formControlStep3Abn.setValue(applicationToAbn(this.existingApplication))
      this.formControlStep3Acn.setValue(applicationToAcn(this.existingApplication));
      this.formControlStep3AnnualRevenue.setValue(applicationToRevenue(this.existingApplication));
      const primaryIndustry = applicationToPrimaryIndustry(this.existingApplication);
      console.log("primaryIndustry",primaryIndustry)
      const industrySector = applicationToIndustrySector(this.existingApplication);
      this.formControlStep3PrimaryIndustry.setValue(primaryIndustry);
      // Set division code for secondary industry component
      this.step3PrimaryIndustryDivisionCode = primaryIndustry?.code ?? null;
      this.step3IndustrySectorGroupCode = industrySector?.code ?? null;
      this.formControlStep3IndustrySector.setValue(industrySector);
      this.formControlStep3SubdivisionIndustrySector.setValue(applicationToSubdivisionIndustrySector(this.existingApplication));

      this.formControlStep3Address.setValue(applicationToPrimaryAddress(this.existingApplication));
      this.formControlStep3RegisteredBusinessAddress.setValue(applicationToRegisteredBusinessAddress(this.existingApplication));
      // 4
      this.step4StoredApplicant = applicationToApplicants(this.existingApplication);
      this.formControlStep4Applicant.setValue(this.step4StoredApplicant);
      if (this.formControlStep4Applicant.value !== null) {
        let propertyOwner: any
        let residentialAddress: any
        if (isApplicationApplicantsSoleTrader(this.formControlStep4Applicant.value)) {
          propertyOwner = this.formControlStep4Applicant.value.propertyOwner;
          residentialAddress = this.formControlStep4Applicant.value.residentialAddress;
        }
        else {
          const applicant = this.formControlStep4Applicant.value;
          for (let i = 0; i <= applicant.length - 1; i++) {
            const currentApplicant = applicant[i];
            if (isApplicationApplicantIndividual(currentApplicant)) {
              propertyOwner = currentApplicant.propertyOwner;
              residentialAddress = currentApplicant.residentialAddress;
            }
          }
        }
        if (propertyOwner) {
          if (propertyOwner.propertyOwner) {
            if (isAddressEquals(residentialAddress, propertyOwner.address)) {
              this.showAddressFormFlag = false;
            }
          }
        }
      }

      // 5
      this.formControlStep5Guarantors.setValue(applicationToGuarantors(this.existingApplication));

      // 6 is the individual details step - it loads its own rows from ApplicationIndividual

      // 7
      this.formControlStep7BrokerflowDocumentId.setValue(applicationToBrokerFlowDocumentId(this.existingApplication));
      this.formControlStep7References.setValue(applicationToReferences(this.existingApplication));

      // 8-10
      this.formControlStep10ApplicationNotes.setValue(applicationToApplicationNotes(this.existingApplication));
      this.listUploadedDocuments();
      this.refreshRequiredTrustDeeds();

      this.documentTypes = this.existingApplication.DocumentTypes ?? [];

    } else {  // not prepopulating ie. creating new application

      // auto populate originator business if we have one
      const orignatorBusinessId = this.user?.OriginatorBusinessId;
      if (orignatorBusinessId) {
        this.subscriptions.push(this.applicationService.getOriginatorBusinessById(orignatorBusinessId).pipe(
          tap(r => {
            if (r.payload) {
              const originatorBusiness: OriginatorBusiness = r.payload;
              const v: AggregatorSearchComponentValue = {
                abn: originatorBusiness.ABN,
                entityName: originatorBusiness.EntityName,
                salesforceId: originatorBusiness.SalesforceId,
                Type: originatorBusiness.Type,
              }
             
              this.formControlStep1Broker.setValue(v);
            }
          })
        ).subscribe());
      }
    }
  }

  initStep1() {
    // step 1:
    this.formControlStep1Business = this.formBuilder.control(null, [Validators.required]);
    this.formControlStep1Broker = this.formBuilder.control(null, [Validators.required]);
    this.formControlStep1PreviousBusiness =  this.formBuilder.control(null, [previousBusinessNotPrimaryValidator(() => this.formControlStep1Business.value)]);
    this.formControlStep1ShowCorrespondent = this.formBuilder.control(false)
    this.formControlStep1Correspondent = this.formBuilder.control(null);
    this.formControlStep1BrokerContact = this.formBuilder.control(null, [Validators.required]);
    this.formGroupStep1 = this.formBuilder.group({
      broker: this.formControlStep1Broker,
      business: this.formControlStep1Business,
      showCorrespondent: this.formControlStep1ShowCorrespondent,
      correspondent: this.formControlStep1Correspondent,
      brokerContact:this.formControlStep1BrokerContact,
      previousBusiness: this.formControlStep1PreviousBusiness,
    });
    this.step1BrokerSearchFn = (term)=> {
      return this.applicationService.searchBroker2(term).pipe(map(r => r.payload));
    }
    setStepper2StepConfig(this.formGroupStep1, {
      nextStepClickedFn: async (stepper) => {
        const currentBizValue = this.formControlStep1Business.value;
        const currentResult = currentBizValue?.type === 'search-result' ? currentBizValue.result : undefined;
        const gstAge = searchResultToGstAgeMonths(currentResult, 0);
        const gstThreshold = this.step1GstThreshold();
        if (currentBizValue?.type !== 'search-result' || gstAge >= gstThreshold) {
          await this.saveApplication(stepper, 1);
          return;
        }
        const gstAgeWithContinuity = searchResultToGstAgeMonthsWithContinuity(
          currentResult,
          this.formControlStep1PreviousBusiness.value,
          gstAge,
        );
        if (gstAgeWithContinuity < gstThreshold && !await this.confirmGstAgeException()) {
          return;
        }
        await this.saveApplication(stepper, 1);
      },
      previousStepClickedFn: async (stepper) => {
        if(this.applicationId){
          await this.router.navigateByUrl(navigationUrlForApplicationsWithQueryParams(this.router, this.queryParams));
        }else {
          await this.router.navigateByUrl(navigationUrlForAssetProductSelectorWithQueryParams(this.router, undefined, this.queryParams));
        }
      }
    });

    this.step1SearchFn = this.applicationService.businessSearchFn
    this.step1GetUserSameCompanyFn = (orgSalesforceId: string) => {
      return this.authService.getOtherUsersInCompanyBySalesforceIdFn(orgSalesforceId).pipe(
        map(r => {
          // exclude this user
          const filteredCorrespndentUserList =  r.filter(u => u.UserId != this.user.UserId);
          this.step1NoOtherUsersInCompany = filteredCorrespndentUserList.length == 0;
          return filteredCorrespndentUserList;
        })
      );
    }
    this.step1GetSalesforceContactSameAccountFn = this.authService.getSalesforceContactSameAccountFn;



    this.subscriptions.push(this.formControlStep1Broker.valueChanges.pipe(
      tap(broker => {
        if (broker) {
           
          this.step1OrgSalesforceId = broker.salesforceId;
          this.step1GetUserSameCompanyFn(this.step1OrgSalesforceId).pipe().subscribe();
          if (broker.Type && broker.Type === 'vendor') {
            this.isVendorUser = true;
            this.brokerageSelectionTitle = 'Commission'; // Set title for vendor user
            this.formControlStep2Brokerage.setValue({type: "0", name: "0%"});
          } else {
            
            this.isVendorUser = false;
            this.formControlStep2Brokerage.setValue({type: "4.0", name: "4.00%"});
            this.brokerageSelectionTitle = 'Brokerage'; // Default title
          }
          
        }
      })
    ).subscribe());
    this.subscriptions.push(this.formControlStep1ShowCorrespondent.valueChanges.pipe(
      tap((r)=> {
        if(!r){
          this.formControlStep1Correspondent.setValue(null)
        }
      })
    ).subscribe())
    this.subscriptions.push(this.formControlStep1Business.valueChanges.pipe(
      tap((r: BusinessSearchValue) => {
        if (r && r.type === 'search-result') { // NOTE: we can deduce only when business is a ASIC/ACN search
          if (r.result?.entityType) {
            const description = r.result.entityType.entityDescription;
            const code = r.result.entityType.entityTypeCode;

            if ('IND' == code) {
              this.formControlStep3OrganisationType.setValue(EntityTypeSoleTraderOption);
            } else if (description && description.toLowerCase().indexOf('trust') >= 0) {
              this.formControlStep3OrganisationType.setValue(EntityTypeTrustOption);
            } else if (description && description.toLowerCase().indexOf('company') >= 0) {
              this.formControlStep3OrganisationType.setValue(EntityTypeCompanyOption);
            } else if (description && description.toLowerCase().indexOf('partnership') >= 0) {
              this.formControlStep3OrganisationType.setValue(EntityTypePartnershipOption);
            } else {
              this.formControlStep3OrganisationType.setValue(EntityTypeOtherOption);
            }
          }
        }
      })
    ).subscribe());

    const sub = this.formControlStep1Business.valueChanges.pipe(
      tap((r: BusinessSearchValue) => {
        if (r) {
          if (r) {
            if (r.abn && this.formControlStep3Abn) {
              this.formControlStep3Abn.setValue(r.abn);
            }
            if (r.acn && this.formControlStep3Acn) {
              const acn = patchAcn(r.acn);
              this.formControlStep3Acn.setValue(acn ?? null);
            }
            this.organisationName = toInteflowLegalName(r) ?? '';
          }
        }
      })
    ).subscribe();
    this.subscriptions.push(sub);

    // previousBusiness stays optional: a GST age below the product threshold is a policy exception
    // the user confirms on Next, not a blocking validation error.
    const sub2 = this.formControlStep1Business.valueChanges.subscribe(v => {
      if (v && v.type === 'search-result') { // NOTE: only when business is done through ASIC/ABN search
          const GSTAge = searchResultToGstAgeMonths(v.result, 0);
          if (GSTAge >= this.step1GstThreshold()) {
              this.formControlStep1PreviousBusiness.setValue(null);
          }
      } else if (!this.formControlStep1PreviousBusiness.value) {
          this.formControlStep1PreviousBusiness.setValue(null);
      }
      this.formControlStep1PreviousBusiness.updateValueAndValidity({ emitEvent: false });
    })
    this.subscriptions.push(sub2);

    const sub3 = this.formControlStep1PreviousBusiness.valueChanges.pipe(
      filter(v => v != null && !v.abrResult && !!v.abn),
      switchMap(v => this.applicationService.getAbrResultByAbn(v!.abn!).pipe(
        map(abrResult => ({ v, abrResult }))
      ))
    ).subscribe(({ v, abrResult }) => {
      if (abrResult && v) {
        this.formControlStep1PreviousBusiness.setValue({ ...v, abrResult }, { emitEvent: false });
      }
    });
    this.subscriptions.push(sub3);
  }

  private step1GstThreshold(): number {
    return this.productType === 'FAST DOC' ? 24 : 12;
  }

  private async confirmGstAgeException(): Promise<boolean> {
    const result = await this.applicationDialogService
      .openAbnGstAgeExceptionDialog()
      .afterClosed()
      .toPromise();
    return !!result?.readyForSubmission;
  }

  initStep2() {
    // step 2:
    this.formControlStep2InvoiceAmount = this.formBuilder.control(null, [Validators.required]);
    this.formControlStep2DepositAmount = this.formBuilder.control(0, [Validators.required]);
    this.formControlStep2LoanAmount = this.formBuilder.control(null, [Validators.required ]);
    this.formControlStep2Asset = this.formBuilder.control(null, [Validators.required]);
    this.formControlStep2AssetCondition = this.formBuilder.control(null, [Validators.required]);
    this.formControlStep2LoanTerms = this.formBuilder.control(null, [Validators.required]);
    this.formControlStep2PaymentFrequency = this.formBuilder.control( { type: 'Monthly', name: 'Monthly'}, [Validators.required]);
    this.formControlStep2FinanceType = this.formBuilder.control(null, [Validators.required]);
    this.formControlStep2DocFeeFinanced = this.formBuilder.control(true, [Validators.required]);
    this.formControlStep2BalloonPayment = this.formBuilder.control(BalloonPaymentValueOptions[0], [Validators.required]);
    this.formControlStep2BrokerOriginationFee = this.formBuilder.control(0, [Validators.required]);
    this.formControlStep2Brokerage = this.formBuilder.control(null, [Validators.required]);
    this.formControlStep2PropertyOwner = this.formBuilder.control(true, [Validators.required]);
    this.formControlStep2AdverseOnFile = this.formBuilder.control(false, [Validators.required]);
    this.formControlStep2EquifaxScoreAboveThreshold = this.formBuilder.control(true, [Validators.required]);
    this.formControlStep2EquifaxDirectorScoreAbove700 = this.formBuilder.control(true, [Validators.required]);
    this.formControlStep2TransactionType = this.formBuilder.control(null, [Validators.required]);
    this.formControlStep2AssetPurpose = this.formBuilder.control(null);

    this.step2AssetSearchFn = this.redbookService.assetSearchFn;
    this.formGroupStep2 = this.formBuilder.group({
      invoiceAmount: this.formControlStep2InvoiceAmount,
      depositAmount: this.formControlStep2DepositAmount,
      loanAmount: this.formControlStep2LoanAmount,
      asset: this.formControlStep2Asset,
      assetCondition: this.formControlStep2AssetCondition,
      loanTerms: this.formControlStep2LoanTerms,
      paymentFrequency: this.formControlStep2PaymentFrequency,
      financeType: this.formControlStep2FinanceType,
      docFeeFinanced: this.formControlStep2DocFeeFinanced,
      balloonPayment: this.formControlStep2BalloonPayment,
      brokerOriginationFee: this.formControlStep2BrokerOriginationFee,
      brokerage: this.formControlStep2Brokerage,
      propertyOwner: this.formControlStep2PropertyOwner,
      adverseOnFile: this.formControlStep2AdverseOnFile,
      equifaxScoreAboveThreshold: this.formControlStep2EquifaxScoreAboveThreshold,
      equifaxDirectorScoreAbove700: this.formControlStep2EquifaxDirectorScoreAbove700,
      transactionType: this.formControlStep2TransactionType,
      assetPurpose: this.formControlStep2AssetPurpose,
    });


    this.formControlStep2TransactionType.valueChanges.pipe(
      tap((r)=> {
         if(r && r.type){
          this._showAssetPurpose = true
          this.formControlStep2AssetPurpose.setValidators([Validators.required]);
         } else {
            this._showAssetPurpose = false
            this.formControlStep2AssetPurpose.clearValidators();
            this.formControlStep2AssetPurpose.setValue(null);
         }
         this.formControlStep2AssetPurpose.updateValueAndValidity();
      })
    ).subscribe();

    const subBalloonDisable = combineLatest([
      this.formControlStep2FinanceType.valueChanges.pipe(startWith(this.formControlStep2FinanceType.value)),
      this.formControlStep2LoanTerms.valueChanges.pipe(startWith(this.formControlStep2LoanTerms.value)),
    ]).pipe(
      tap(([financeType, loanTermValue]) => {
        const isRental = financeType?.type === 'rental';
        const isLongTerm = loanTermValue && loanTermValue > 60;
        if (isRental || isLongTerm) {
          this.formControlStep2BalloonPayment.setValue(BalloonPaymentValueOptions[0]);
          this.formControlStep2BalloonPayment.disable();
        } else {
          this.formControlStep2BalloonPayment.enable();
        }
      })
    ).subscribe();
    this.subscriptions.push(subBalloonDisable);

    setStepper2StepConfig(this.formGroupStep2, {
      nextStepClickedFn: async stepper => {
        // Mark form group as touched to trigger all validations
        this.formGroupStep2.markAllAsTouched();
        
        if (this.formControlStep2Asset?.value?.invalid) {
          this.applicationDialogService.openAlertDialog({
            message: `Validation Error`,
            subMessage: 'Please complete all required asset fields'
          });
          return;
        }
        
        // Check asset condition validation by accessing the component's internal formControl
        if (this.assetConditionComponent?.formControl) {
          // Mark the internal control as touched
          this.assetConditionComponent.formControl.markAsTouched();
          
          if (this.assetConditionComponent.formControl.hasError('assetYearValidation')) {
            this.applicationDialogService.openAlertDialog({
              message: `Asset Condition Validation Error`,
              subMessage: this.assetConditionComponent.formControl.errors?.['assetYearValidation'] || 'Please correct the asset condition'
            });
            return;
          }
        }

        // A "New" asset can only be Dealer Sale, Internal Re-write or Sales and Lease Back
        const assetConditionValue = this.formControlStep2AssetCondition.value;
        const transactionTypeValue = this.formControlStep2TransactionType.value;
        if (assetConditionValue?.type === 'New' && !isTransactionTypeAllowedForNewAsset(transactionTypeValue?.type)) {
          const allowedTransactionTypes = getAllowedTransactionTypesForNewAsset(isInternalUser(this.user));
          this.applicationDialogService.openAlertDialog({
            message: `Validation Error`,
            subMessage: `A "New" asset can only have a Transaction Type of ${allowedTransactionTypes.map(t => `"${t}"`).join(' or ')}. Please update the Transaction Type or Asset Condition.`
          });
          return;
        }
        
        // Check loan purpose validation if shown
        if (this._showAssetPurpose) {
          // Mark all fields as touched to trigger validation
          this.loanPurposeComponent.mark();
          
          // Check if the form group is invalid
          if (this.loanPurposeComponent.formGroup.invalid) {
            this.applicationDialogService.openAlertDialog({
              message: `Validation Error`,
              subMessage: 'Please complete all required loan purpose fields'
            });
            return;
          }
        }

        // Validate End of Term (EOT) age
        const asset = this.formControlStep2Asset.value;
        const loanTerms = this.formControlStep2LoanTerms.value;
        
        if (asset && loanTerms && asset.year && asset.category && asset.category.index) {
          const assetYear = parseInt(asset.year);
          if (!isNaN(assetYear) && !isNaN(loanTerms) && assetYear > 0 && loanTerms > 0) {
            const validation = validateEOTAge(assetYear, asset.category.index, loanTerms, asset.type?.index);
            
            if (!validation.isValid && validation.errorMessage) {
              this.applicationDialogService.openAlertDialog({
                message: `End of Term Validation Error`,
                subMessage: validation.errorMessage
              });
              return;
            }
          }
        }

        // If validation passes, proceed with quotation
        await this.step2ShowQuotation(stepper);
        this.documentTypes = this.applicationDefaultDocuments(false);
      },
      nextStepButtonText: `Calculate Repayments`,
    });
    const subscription = combineLatest([
      this.formControlStep2InvoiceAmount.valueChanges,
      this.formControlStep2DepositAmount.valueChanges,
      this.formControlStep2FinanceType.valueChanges,
    ]).pipe(
      tap(r => {
        const invoiceAmount = r[0] ?? 0;
        const depositAmount = r[1] ?? 0;
        const financeType = r[2];
        const depositAmountExGST = Math.round(depositAmount * 1000 / 11) / 100;
        const deposit = financeType?.type === 'rental' ? depositAmountExGST : depositAmount;
        const loanAmount = parseFloat((invoiceAmount - deposit > 0) ? (invoiceAmount - deposit).toFixed(2) : '0');
        this.formControlStep2LoanAmount.setValue(loanAmount);
        // Re-cap the balloon so its amount can't exceed the new loan amount (invoice - deposit)
        this.step2UpdateBalloonPaymentValidation(this.formControlStep2Asset.value, this.formControlStep2LoanTerms.value);
      })
    ).subscribe();
    this.subscriptions.push(subscription);

    // deposit calculation trigger
    this.subscriptions.push(this.formControlStep2InvoiceAmount.valueChanges.pipe(
      tap(r => {
        this.step2UpdateDepositValidation();
      })
    ).subscribe());
    this.subscriptions.push(this.formControlStep2PropertyOwner.valueChanges.pipe(
      tap(r => {
        this.step2UpdateDepositValidation();
      })
    ).subscribe());
    this.subscriptions.push(...linkEquifaxDirectorScoreControls(
      this.formControlStep2EquifaxScoreAboveThreshold,
      this.formControlStep2EquifaxDirectorScoreAbove700,
    ));
    this.subscriptions.push(this.formControlStep2Asset.valueChanges.pipe(
      tap(r => {
        this.step2UpdateDepositValidation();
        // When Solar System is selected, set Finance Type to Chattel Mortgage and disable
        if (r && r.category && r.category.index === '106') {
          this.formControlStep2FinanceType.disable();
          const chattelMortgageOption = FinanceTypeValueOptions.find(o => o.type === 'chattel-mortgage');
          this.formControlStep2FinanceType.setValue(chattelMortgageOption ?? null);
        } else {
          this.formControlStep2FinanceType.enable();
        }
        // Restrict max loan term based on asset tier
        if (r && r.category && r.category.index) {
          this.step2MaxLoanTerm = getMaxLoanTermForTier(r.category.index);
        } else {
          this.step2MaxLoanTerm = 84;
        }
      })
    ).subscribe());

  }

  initStep3() {
    // step 3: Company details
    this.formControlStep3OrganisationType = this.formBuilder.control(null, [Validators.required]);
    this.formControlStep3Abn = this.formBuilder.control(null, [Validators.required]);
    this.formControlStep3Acn = this.formBuilder.control(null);
    this.formControlStep3AnnualRevenue = this.formBuilder.control(null, [Validators.required]);
    this.formControlStep3PrimaryIndustry = this.formBuilder.control(null, [Validators.required]);
    this.formControlStep3IndustrySector = this.formBuilder.control(null, [Validators.required]);
    this.formControlStep3SubdivisionIndustrySector = this.formBuilder.control(null, [Validators.required]);
    this.formControlStep3Address = this.formBuilder.control(null, [Validators.required]);
    this.formControlStep3RegisteredBusinessAddress = this.formBuilder.control(null, [Validators.required]);
    this.formGroupStep3 = this.formBuilder.group({
      organisationType: this.formControlStep3OrganisationType,
      abn: this.formControlStep3Abn,
      acn: this.formControlStep3Acn,
      annualRevenue: this.formControlStep3AnnualRevenue,
      primaryIndustry: this.formControlStep3PrimaryIndustry,
      industrySector: this.formControlStep3IndustrySector,
      industryClass: this.formControlStep3SubdivisionIndustrySector,
      address: this.formControlStep3Address,
      registeredBusinessAddress: this.formControlStep3RegisteredBusinessAddress,
    });
    // Identify the applicant, so they come from step 1's verified business search and are not
    // re-typed here: changing them would invalidate the company check this step waits on.
    this.formControlStep3Abn.disable();
    this.formControlStep3Acn.disable();
    this.step3KybResultFn = this.applicationService.kybResultFn;
    this.step3KybRefreshFn = this.applicationService.kybRefreshFn;
    this.kybSetManualModeFn = this.applicationService.kybSetManualModeFn;

    const sub = this.formControlStep3OrganisationType.valueChanges.pipe(
      tap((r: EntityTypeValue) => { // change org type, clear applicant field.
        if (r) {
          if(this.step3OnwardsOrganisationType && this.step3OnwardsOrganisationType !== r.type) {
            // the org type changes and is different from prev value
            this.formControlStep4Applicant.setValue(null)
          }
          this.step3OnwardsOrganisationType = r.type;
          if (r.type === 'company') {
            this.formControlStep3Acn.setValidators([Validators.required]);
          } else {
            this.formControlStep3Acn.setValidators(null);
            this.formControlStep3Acn.updateValueAndValidity();
          }
        }
      })
    ).subscribe();
    this.subscriptions.push(sub);

    // Listen for primary industry changes and fetch secondary industries
    const primaryIndustrySub = this.formControlStep3PrimaryIndustry.valueChanges.pipe(
      tap((primaryIndustry: PrimaryIndustrySelectionValue) => {
        if (primaryIndustry && primaryIndustry.code) {
          // Clear current secondary industry selection
          this.formControlStep3IndustrySector.setValue(null);
          this.formControlStep3SubdivisionIndustrySector.setValue(null);
          
          // Update division code for secondary industry component
          this.step3PrimaryIndustryDivisionCode = primaryIndustry.code;
          this.step3IndustrySectorGroupCode = null;
        } else {
          // Clear division code when primary industry is cleared
          this.step3PrimaryIndustryDivisionCode = null;
          this.formControlStep3IndustrySector.setValue(null);
          this.formControlStep3SubdivisionIndustrySector.setValue(null);
        }
      })
    ).subscribe();
    this.subscriptions.push(this.formControlStep3IndustrySector.valueChanges.pipe(
      tap((secondaryIndustry: SecondaryIndustrySelectionValue) => {
        if (secondaryIndustry && secondaryIndustry.code) {
          this.step3IndustrySectorGroupCode = secondaryIndustry.code;
          this.formControlStep3SubdivisionIndustrySector.setValue(null);
        }else{
          this.step3IndustrySectorGroupCode = null;
          this.formControlStep3SubdivisionIndustrySector.setValue(null);
        }
      })
    ).subscribe());
 
    this.subscriptions.push(primaryIndustrySub);
    setStepper2StepConfig(this.formGroupStep3, {
      stepSelectionEventFn: () => {
        this.step3Active = true;
      },
      // The form is not on screen until the company check lands, so there is nothing to advance to.
      nextStepButtonDisabledFn: () => this.step3AwaitingKyb,
      nextStepClickedFn: async stepper => {
        await this.saveApplication(stepper, 3);
      }
    });
  }

  /**
   * The applicant's company check finished. Prefill both addresses from the registry into their
   * matching fields, leaving anything the broker already saved on a previous visit alone, and keep
   * the result for step 4.
   */
  onStep3KybResolved(result: KybResult) {
    this.step3KybResult = result;
    const primaryEntity = result.entities.find(entity => entity.isPrimary);
    this.step3ManualKyb = primaryEntity?.mode === 'MANUAL';
    const addresses = primaryEntity?.addresses ?? null;
    // Tested on the address line rather than the object: a saved entity with an empty address still
    // hydrates into a fully-shaped value, which reads as answered while showing the broker nothing.
    if (addresses?.registeredOffice && !this.formControlStep3RegisteredBusinessAddress.value?.address) {
      this.formControlStep3RegisteredBusinessAddress.setValue(addresses.registeredOffice);
    }
    if (addresses?.principalPlaceOfBusiness && !this.formControlStep3Address.value?.address) {
      this.formControlStep3Address.setValue(addresses.principalPlaceOfBusiness);
    }
  }

  onStep3ManualKyb(): void {
    if (this.applicationId == null) return;
    this.kybSetManualModeFn(this.applicationId).subscribe({
      next: result => this.onStep3KybResolved(result),
      error: () => undefined,
    });
  }

  initStep4() {
    // step 4: Key People (KYB)
    // The visible Step 4 is now the KYB summary screen. The legacy applicant control is retained
    // (null, unvalidated) so the existing save/confirmation paths keep compiling and null-safe.
    // Capturing detailed individual data is a separate follow-up ticket.
    this.step4BusinessSearchFn = this.applicationService.businessSearchFn;
    this.step4BusinessNumberSearchFn = this.applicationService.businessNumberSearchFn;
    this.step4KybResultFn = this.applicationService.kybResultFn;
    this.step4KybInitiateCorporatePartyFn = this.applicationService.kybInitiateCorporatePartyFn;
    this.formControlStep4Applicant = this.formBuilder.control(null);
    this.formControlStep4KybKeyPeople = this.formBuilder.control(null, [Validators.required]);
    this.formGroupStep4 = this.formBuilder.group({
      applicant: this.formControlStep4Applicant,
      kybKeyPeople: this.formControlStep4KybKeyPeople,
    });
    setStepper2StepConfig(this.formGroupStep4, {
      stepSelectionEventFn: () => {
        this.step4Active = true;
      },
      nextStepValidationMessage: KYB_KEY_PEOPLE_STEP_VALIDATION_MESSAGE,
      nextStepClickedFn: async stepper => {
        if (!await this.confirmStep4KybWarnings()) {
          return;
        }
        await this.saveApplication(stepper, 4);
      }
    });
  }

  // KYB warnings are advisory, so they are raised here (on Next) rather than inline on the step;
  // continuing is allowed once the user confirms.
  private async confirmStep4KybWarnings(): Promise<boolean> {
    if (!this.step4KybWarnings.length) {
      return true;
    }
    const result = await this.applicationDialogService
      .openKybWarningsConfirmationDialog(this.step4KybWarnings)
      .afterClosed()
      .toPromise();
    return !!result?.readyForSubmission;
  }

  initStep5() {
    // step 5:
    this.step5CompanySearchFn = this.applicationService.businessSearchFn;
    this.step5BusinessNumberSearchFn = this.applicationService.businessNumberSearchFn;
    this.formControlStep5Guarantors = this.formBuilder.control(null, [requiredAllowEmptyValidator]);
    this.formGroupStep5 = this.formBuilder.group({
      guarantors: this.formControlStep5Guarantors,
    });
    // No "at least one guarantor" rule: the required guarantors are captured on Key People, and
    // this step only collects the additional ones the company check did not return.
    this.formGroupStep5.setValidators([
      // A guarantor entity may never be the same business as the primary entity or a trustee /
      // partner (borrowing) entity.
      guarantorEntityValidator(() => ({
        guarantors: this.formControlStep5Guarantors.value,
        applicant: this.formControlStep4Applicant.value,
        primaryBusiness: { abn: this.formControlStep3Abn.value, acn: this.formControlStep3Acn.value },
      })),
    ]);
    setStepper2StepConfig(this.formGroupStep5, {
      nextStepClickedFn: async stepper => {
        await this.saveApplication(stepper, 5);
      }
    });
  }

  // individual details review, including the primary contact selection
  initStep6() {
    this.formControlStep6IndividualDetails = this.formBuilder.control(null);
    this.formGroupStep6 = this.formBuilder.group({
      individualDetails: this.formControlStep6IndividualDetails,
    });
    setStepper2StepConfig(this.formGroupStep6, {
      stepSelectionEventFn: e => {
        // re-read from the DB every time the step is entered - the KYB key people and guarantor
        // steps may have added or changed individuals in between. Wait on the previous step's
        // draft save first, otherwise this read races the write that creates those rows and a
        // guarantor added on the step before wouldn't show up until the step is re-entered.
        this.individualDetailsListComponent?.reload(this.pendingDraftSave);
      },
      previousStepClickedFn: async stepper => {
        // flush pending edits so navigating back doesn't lose them
        await this.individualDetailsListComponent?.flushChanges();
        stepper.previous();
      },
      nextStepClickedFn: async stepper => {
        // persists through /save-application-parties; deliberately NOT updateDraftInBg - the
        // legacy Individuals payload rebuilt from earlier step values would overwrite the edits
        // that were just saved on this step. mapToInteflowData re-applies them on later saves.
        const flushed = await this.individualDetailsListComponent?.flushChanges() ?? true;
        if (flushed) {
          stepper.next();
        }
      },
    });
  }
  
  initStep7() {  // reference
    // step 7
    this.formControlStep7BrokerflowDocumentId = this.formBuilder.control(null);
    this.formControlStep7References = this.formBuilder.control(null, [requiredAllowEmptyValidator]);
    this.formGroupStep7 = this.formBuilder.group({
      brokerflowDocumentId: this.formControlStep7BrokerflowDocumentId,
      references: this.formControlStep7References,
    });
    setStepper2StepConfig(this.formGroupStep7, {
      nextStepClickedFn: async stepper => {
        await this.saveApplication(stepper, 7);
      }
    });
  }

  // trust deeds
  initStep8() {
    this.formControlStep8TrustDeeds = this.formBuilder.control(null);
    this.formGroupStep8 = this.formBuilder.group({
      trustDeeds: this.formControlStep8TrustDeeds,
    });
    setStepper2StepConfig(this.formGroupStep8, {
      nextStepButtonText: 'Next',
      // Uploading is optional, so the step never blocks Next; a deed not supplied here stays a
      // required document on the Documents tab after submission.
      nextStepClickedFn: async stepper => {
        await this.saveApplication(stepper, 8);
      },
    });
  }

  /**
   * Re-derive which entities need a deed. Called as the parties settle, since a trust added at the
   * guarantor step changes the answer.
   */
  refreshRequiredTrustDeeds() {
    if (!this.applicationId) {
      return;
    }
    this.subscriptions.push(
      this.applicationService.requiredTrustDeedsFn(this.applicationId).subscribe({
        next: deeds => this.requiredTrustDeeds = deeds,
        // Leaves the step hidden; the deeds are still collected as conditions after submission.
        error: () => this.requiredTrustDeeds = [],
      }),
    );
  }

  onStep8DeleteUploadedDoc(deletedFile: AzureStorageDocument) {
    this.step8DeletedUploadedDocs = [...this.step8DeletedUploadedDocs, deletedFile];
    this.step9UploadedDocs = this.step9UploadedDocs.filter(doc => doc.name !== deletedFile.name);
  }

  // other supporting doc
  initStep9() {
    this.formControlStep9OtherSupportingDocuments = this.formBuilder.control(null,[duplicateFileNameValidator()]);
    this.formGroupStep9 = this.formBuilder.group({
      otherSupportingDocuments: this.formControlStep9OtherSupportingDocuments,
    });
    setStepper2StepConfig(this.formGroupStep9, {
      nextStepButtonText: 'Next',
      stepSelectionEventFn: e => {
        this.documentTypes = this.applicationDefaultDocuments(true);
      },
      nextStepClickedFn: async stepper => {

        const isMissingTagsCheck = this.formGroupStep9.value.otherSupportingDocuments?.filter(file => file.tags && file.tags.length === 0) ;
        if(isMissingTagsCheck?.length){
          const fileNames = isMissingTagsCheck.map(file => file.name).join(', ');
          this.applicationDialogService.openAlertDialog({
             message: `Validation Error`,
             subMessage: `The following files are missing tags: ${fileNames}`
           });
        }else {

          await this.saveApplication(stepper, 9);
        }

      },

    });
  }

  // application note
  initStep10() {
    this.formControlStep10ApplicationNotes = this.formBuilder.control(null);
    this.formGroupStep10 = this.formBuilder.group({
      applicationNotes: this.formControlStep10ApplicationNotes,
    });
    setStepper2StepConfig(this.formGroupStep10, {
      nextStepButtonText: 'Next to Review',
      nextStepClickedFn: async stepper => {
        await this.saveApplication(stepper, 10);
      }
    });
  }

  initStep11() {
    this.formGroupStep11 = this.formBuilder.group({ });
    setStepper2StepConfig(this.formGroupStep11, {
      nextStepButtonText: 'Submit',
      nextStepClickedFn: async stepper => {
        await this.finalSubmission(stepper);
      },
      
      stepSelectionEventFn: e => {
        const assetData = this.formControlStep2Asset.value;
        if (assetData) {
          assetData.LoanPurpose = this.formControlStep2AssetPurpose.value;
        }

        this.step11Summary = {
          broker: this.formControlStep1Broker.value,
          balloonPayment: this.formControlStep2BalloonPayment.value,
          balloonPaymentValue: this.terms?.RV??0,
          depositAmount: this.formControlStep2DepositAmount.value!,
          loanAmount: this.formControlStep2LoanAmount.value!,
          references: this.formControlStep7References.value,
          brokerFlowId: this.formControlStep7BrokerflowDocumentId.value!,
          isSwitchToEasyDoc : this.isSwitchToEasyDoc,
          productType: this.productType,
          repayment: String(this.step2Repayment),
          estimatedDrawDownDate: this.step2EstimatedDrawdownDate,
          brokerApplicationId: this.brokerApplicationId ?? '',
          organisation: this.formControlStep1Business.value,
          addtionalBrokerCorrespondent: this.formControlStep1Correspondent.value,
          organisationType: this.formControlStep3OrganisationType.value,
          abn: this.formControlStep3Abn.value!,
          acn: this.formControlStep3Acn.value!,
          financeType: this.formControlStep2FinanceType.value,
          annualRevenue: this.formControlStep3AnnualRevenue.value!,
          primaryIndustry: this.formControlStep3PrimaryIndustry.value,
          industrySector:  this.formControlStep3IndustrySector.value,
          subdivisionIndustrySector: this.formControlStep3SubdivisionIndustrySector.value,
          address: this.formControlStep3Address.value,
          registeredBusinessAddress: this.formControlStep3RegisteredBusinessAddress.value,
          asset: assetData,
          assetCondition: this.formControlStep2AssetCondition.value,
          invoiceAmount: this.formControlStep2InvoiceAmount.value!,
          loanTerms: this.formControlStep2LoanTerms.value,
          transactionType: this.formControlStep2TransactionType.value,
          equifaxScoreAboveThreshold: this.formControlStep2EquifaxScoreAboveThreshold.value,
          equifaxDirectorScoreAbove700: this.formControlStep2EquifaxDirectorScoreAbove700.value,
          adverseOnFile: this.formControlStep2AdverseOnFile.value,
          propertyOwner: this.formControlStep2PropertyOwner.value,
          brokerage: this.formControlStep2Brokerage.value,
          paymentFrequency: this.formControlStep2PaymentFrequency.value,
          docFee: this.formControlStep2DocFeeFinanced.value,
          brokerOriginationFee: this.formControlStep2BrokerOriginationFee.value!,
          applicants: this.formControlStep4Applicant.value ?? [],
          guarantors: this.formControlStep5Guarantors.value,
          primaryContact: savedIndividualsToPrimaryContact(this.formControlStep6IndividualDetails.value?.individuals)!,
          contacts: savedIndividualsToContacts(this.formControlStep6IndividualDetails.value?.individuals),
          loanPurpose: this.formControlStep2AssetPurpose.value,
          applicationNotes: this.formControlStep10ApplicationNotes.value!,
          brokerContact:this.formControlStep1BrokerContact.value!
        };
      }
    });
  }

  async finalSubmission(stepper: CdkStepper) {
    await this.agreeToTermsOfSubmission(stepper);
  }

  async agreeToTermsOfSubmission(stepper: CdkStepper) {
    this.subscriptions.push(consentAcknowledgementIndividuals(
      this.digitalIdService.getApplicationIndividualsFn,
      this.applicationId,
      this.formControlStep6IndividualDetails.value?.individuals,
    ).pipe(
        this.toastService.topMenuLoadingObservable(),
        switchMap(individuals => this.applicationDialogService
          .openAssetFinanceApplicationConfirmationDialog(individuals).afterClosed()),
        tap(async (r) => {
          if (r && r.readyForSubmission) {
            this.businessUseOnly = true;
            this.selfServiceability = true;
            await this.sendFinalSubmission(stepper);
          }
      })
    ).subscribe());
  }

  async sendFinalSubmission(stepper: CdkStepper) {
    if (this.applicationId) {
      const data = await this.mapToInteflowData();
      console.log('asset finance final submission data', data);

      // update driver licence doc metadata - as the individualId will be changed
      if (this.applicationId) {
        this.subscriptions.push(
          this.applicationService.listApplicationDocumentFn(this.applicationId).subscribe(
            (r: AzureStorageDocument[]) => {
              const driverLicenceDocs = r.filter(obj => Object.values(obj?.tags ?? {}).includes('driverslicence'));
              for (const doc of driverLicenceDocs) {
                const individual = (data.parties?.individuals ?? []).find(obj => (doc.metadata?.driverslicencename ?? '') == `${obj.givenName ?? ''} ${obj.surname ?? ''}`);
                if (individual && individual.guid) {
                  this.applicationService.updateDocumentMetadataFn(doc.name, "", {
                    ...doc.metadata,
                    individualid: individual.guid ?? ''
                  }).subscribe()
                }
              }
            }
          )
        )
      }

      // double check legal names for commercial entities
      if (data.parties?.commercialEntities?.length) {
        for (const entity of data.parties.commercialEntities) {
          if (!entity?.legalName)  {
            this.applicationDialogService.openAlertDialog({
              message: `Alert`,
              subMessage: `Missing legal name for some entities.`
            });
            return;
          }
        }
      }

      this.subscriptions.push(this.applicationService.submitApplication(this.applicationId, data).pipe(
        this.toastService.spinnerObservable(),
        tap(r => {
          if (r && r.status) {
            this.applicationDialogService.openApplicationSubmittedDialog().afterClosed().pipe(
              tap(async r => {
                await this.router.navigateByUrl(navigationUrlForApplicationsWithQueryParams(this.router, {reload: true}));
              })
            ).subscribe();
          } else {
            // Handle error response with status 400
            const errorMessage = r?.message || 'Error submitting application';
            this.applicationDialogService.openAlertDialog({
              message: `Error`,
              subMessage: errorMessage
            });
          }
        }),
        catchError(error => {
          // Handle HTTP error response (like 400 Bad Request)
          const errorMessage = error?.error?.message || error?.message || 'Error submitting application';
          this.applicationDialogService.openAlertDialog({
            message: `Error`,
            subMessage: errorMessage
          });
          return of(null);
        })
      ).subscribe({}));
    }
  }

  async uploadFileToAzure(step: number, data: WizardSubmitData) {
    let base64Files: Base64File[] = [];
    let allToBeDeleted: string[] = [];
    let allFiles: File[] = [];
    if (step === 4) {
      allFiles = tagIndividualIdDocumentFiles(
        this.kybKeyPeopleComponent?.manualIdDocumentUploads() ?? [],
        data.parties?.individuals ?? [],
        this.step9OtherDocMetadata,
      );
      allToBeDeleted = this.step4DeletedIdDocuments.map(document => document.name);
    } else if (step === 5) { // guarantor ID documents (driver licence / passport) from the individual form
      const uploads = [
        ...collectIndividualIdDocumentUploads(individualGarantors(this.formControlStep5Guarantors.value)),
        ...(this.guarantorComponent?.manualIdDocumentUploads() ?? []),
      ];
      allFiles = tagIndividualIdDocumentFiles(uploads, data.parties?.individuals ?? [], this.step9OtherDocMetadata);
      allToBeDeleted = this.step5DeletedIdDocuments.map(document => document.name);
    } else if (step === 8) { // trust deeds, already tagged with the condition they were dropped into
      const trustDeeds = this.formControlStep8TrustDeeds.value;
      allToBeDeleted = [...this.step8DeletedUploadedDocs].map(file => file.name);
      if (trustDeeds && trustDeeds.length) {
        allFiles = [...trustDeeds];
      }
    } else if (step === 9) { // other supporting doc
      const otherSupportingDocs: UploadFileValue = this.formControlStep9OtherSupportingDocuments.value;
      allToBeDeleted = [...this.step9DeletedUploadedDocs].map(file => file.name);
      if (otherSupportingDocs && otherSupportingDocs.length) {
        allFiles = [...otherSupportingDocs];
      }
    } else {
      return;
    }

    base64Files = [...await filesToBase64Files(allFiles)];
    // double check if any changes with existing files
    // remove file that has been uploaded
    base64Files = base64Files.map(file => {
      file.metadata = file.tags?.includes('driverslicence') ? file.metadata : this.step9OtherDocMetadata
      return file;
    }).filter(f => {
      const fileIdentifiers = this.filesUploadedToAzure.map(m =>
        `${m.name}${m.tags?.join(' ')}${m.metadata?.individualid ?? m.metadata?.driverslicencename ?? ''}`);
      return !fileIdentifiers.includes(
        `${f.name}${f.tags?.join(' ')}${f.metadata?.individualid ?? f.metadata?.driverslicencename ?? ''}`,
      );
    })
    if (!base64Files.length && !allToBeDeleted.length) {
      return;
    }

    if (this.applicationId) {
      await lastValueFrom(
        this.applicationService.uploadApplicationDocumentToAzureStorage(
          this.applicationId,
          [...base64Files],
          allToBeDeleted,
        ),
      );
      this.filesUploadedToAzure = [...this.filesUploadedToAzure, ...base64Files];
      if(step === 4 || step === 5){
        this.listUploadedDocuments()
        if (step === 4) {
          this.step4DeletedIdDocuments = [];
        } else {
          this.step5DeletedIdDocuments = [];
        }
      }else if(step === 8){
        this.listUploadedDocuments()
        this.step8DeletedUploadedDocs = []
        this.formControlStep8TrustDeeds.setValue(null)
      }else if(step === 9){
        this.uploadFilesMultiTagsComponent.files = []
        this.uploadFilesMultiTagsComponent.filesWithTags = []
        this.uploadFilesMultiTagsComponent.formControl.setValue(null)
        this.listUploadedDocuments()
        this.formControlStep9OtherSupportingDocuments.setValue(null)
      }
    }
  }

  async mapToInteflowData() {

    const user = getUser();
    const org: EntityTypeValue = this.formControlStep3OrganisationType.value;
    const financeType: FinanceTypeValue = this.formControlStep2FinanceType.value;
    const applicationNotes = this.formControlStep10ApplicationNotes.value;
    const brokerflowDocumentId = this.formControlStep7BrokerflowDocumentId.value;
    const broker: AggregatorSearchComponentValue = this.formControlStep1Broker.value;
    const asset: AssetSelectionComponentValue = this.formControlStep2Asset.value;
    // primary contact is selected on the individual details step and flagged on the saved rows
    const savedIndividualDetails = this.formControlStep6IndividualDetails.value;
    const contact: SelectContactValue = savedIndividualsToPrimaryContact(savedIndividualDetails?.individuals);
    const applicants: ApplicationApplicant = this.formControlStep4Applicant.value;
    const guarantors: GuarantorValue = this.formControlStep5Guarantors.value;
    const refValue: ReferenceValue = this.formControlStep7References.value;

    console.log("applicantsapplicants",applicants)
    // workout broker salesforce id
    let brokerSalesforceId = broker!.salesforceId;
    let brokerAbn = broker!.abn;
    let brokerEntityName = broker!.entityName;
    if (user!.BrokerSalesforceId === environment.GrowFinanceGroupSalesforceId) {
      if (broker && broker.salesforceId) {
        brokerSalesforceId = broker.salesforceId;
        brokerAbn = broker.abn;
        brokerEntityName = broker.entityName;
      } else if (this.brokerOfUser && this.brokerOfUser.SalesforceId) {
        brokerSalesforceId = this.brokerOfUser.SalesforceId;
        brokerAbn = this.brokerOfUser.ABN;
        brokerEntityName = this.brokerOfUser.EntityName;
      }
    }
    else {
      if (broker) { // broker dropdown selection is being populated
        // use the declared brokerSalesforceId, brokerAbn and brokerEntityName
      } else if (this.brokerOfUser && this.brokerOfUser.SalesforceId !== undefined) {
        // broker drop down selection is not being populated, we populate it with the current user's company details
        brokerSalesforceId = this.brokerOfUser.SalesforceId;
        brokerAbn = this.brokerOfUser.ABN;
        brokerEntityName = this.brokerOfUser.EntityName;
      }
    }

    // workout disclosure
    let disclosed = true;
    let introducerGroup = 'ECLIPXCOMMERCIAL';
    if (this.brokerOfUser) {
      if (this.brokerOfUser.Relationship !== 'disclosed') {
        disclosed = false;
        introducerGroup = 'UNDISCLOSED_ECLIPXCOMMERCIAL';
      }
    }

    // ====================
    // work out commercial entities
    // =============
    const b: BusinessSearchValue = this.formControlStep1Business.value;
    const c: UserSelectionValue = this.formControlStep1Correspondent.value;
    const o: EntityTypeValue = this.formControlStep3OrganisationType.value;
    const abn = this.formControlStep3Abn.value;
    const acn = this.formControlStep3Acn.value;
    let previousBusiness: BusinessNumberSearchValue = this.formControlStep1PreviousBusiness.value;

    // work out legalName & entityTYpe
    let legalName = toInteflowLegalName(b) ?? undefined;
    let entityType = o ? toInteflowEntityTypes(o.type) : undefined;

    // work out industries
    const primaryIndustry: PrimaryIndustrySelectionValue = this.formControlStep3PrimaryIndustry.value;
    const secondaryIndustry: SecondaryIndustrySelectionValue = this.formControlStep3IndustrySector.value;
    const subdivisionIndustrySector: SubdivisionIndustrySelectionValue = this.formControlStep3SubdivisionIndustrySector.value;
    const revenue = this.formControlStep3AnnualRevenue.value;
    const address: Address2ComponentValue = this.formControlStep3Address.value;
    const registeredAddress: Address2ComponentValue = this.formControlStep3RegisteredBusinessAddress.value;
    // const parsedAddress = address ? parseRawAddress(address.address) : null;
    console.log("Parsed Address::", address);

    // entities
    const primaryCommercialEntity: ApplicationCommercialEntityWrite = {
      legalName: legalName ?? undefined,
      entityType: entityType,
      // Replaces the ACN delete below: a non-company posts no ACN at all, rather than a blank that
      // would overwrite a stored one on the full sync.
      abn: abn ?? undefined,
      acn: (entityType !== 'PTY' || _.isEmpty(acn)) ? undefined : (acn ?? undefined),
      tradingName: '',
      // Replaces Type: 'Primary'. This is the borrower, so it holds no relationship to another entity.
      isPrimary: true,
      isGuarantor: false,
      relationships: [],
      industry: {
        primaryIndustry: primaryIndustry?.code ?? undefined,
        industrySector: secondaryIndustry?.code ?? undefined,
        // This page files the subdivision code under industryClass. The other three file the same
        // control under subdividionClass - preserved as-is either way, see doc §17.6.
        industryClass: subdivisionIndustrySector?.code ?? undefined,
      },
      revenue: revenue ? Number(revenue) : undefined,
      manualEntry: false,
      businessCategory: 'SME ($1m+ Revenue | $0.5m to $5m Capital)',
      principalPlaceOfBusiness: toApiAddress(address),
      registeredBusinessAddress: toApiAddress(registeredAddress),
      abnAgeMonths: (b && b.type === 'search-result' && b?.result) ?
      b.result.ABNAgeMonths :
      this.existingApplication?.CompanyDetails ? this.existingApplication.CompanyDetails.ABNAgeMonths : undefined
    };
    // commercial entities
    const otherCommercialEntities = fromApplicantToInteflowCommercialEntities(applicants);
    const guarantorCommercialEnttities = fromGuarantorToInteflowCommercialEnttities(guarantors);
    const otherCommercialEntity = [
      ...otherCommercialEntities,
      ...guarantorCommercialEnttities,
    ];

    // individuals
    const applicantIndividuals = fromApplicantToInteflowIndividualsData(applicants);
    let guarantorIndividuals = fromGuarantorToInteflowIndividuals(guarantors);

    // for trust application with only corporate trustee, the guarantors are guarantor/signer
    if (entityType === 'TRST' && !applicantIndividuals.length) { // no individual trustee
      guarantorIndividuals =  guarantorIndividuals.map(i => {
        return {
          ...i,
          // Was SignerRole: 'GuarantorSigner'. The write shape carries the two facts the string
          // encoded, and these individuals already guarantee - so this is the signing half.
          isSigner: true,
        }
      })
    }

    const otherIndividuals = [
      ...applicantIndividuals,
      ...guarantorIndividuals,
    ];

    // reference
    const references =  fromReferenceToInteflowReferences(refValue);
    // pricing details
    // NOTE: changes done here needs to be done in asset-pricing.component.ts as well
    const loanTerm: LoanTermsSelectionWithInputValue = this.formControlStep2LoanTerms.value;
    const invoiceAmount = this.formControlStep2InvoiceAmount.value;
    const loanAmount = _.round(this.formControlStep2LoanAmount.value ?? 0, 2);
    const deposit = this.formControlStep2DepositAmount.value;
    const brokerage: BrokerageSelectionValue = this.formControlStep2Brokerage.value;
    const paymentPeriod: PaymentFrequencyValue = this.formControlStep2PaymentFrequency.value;
    const docFeeFinanced = this.formControlStep2DocFeeFinanced.value;
    const docFee = this.terms?.docFee ?? undefined;
    const brokerOriginationFee = this.formControlStep2BrokerOriginationFee.value;
    const propertyOwner = this.formControlStep2PropertyOwner.value;
    const adverseOnFile = this.formControlStep2AdverseOnFile.value;
    const equifaxScore = this.formControlStep2EquifaxScoreAboveThreshold.value;
    const rate = this.terms?.totalInterest ?? undefined;
    const balloonPercentage: BalloonPaymentValue = this.formControlStep2BalloonPayment.value;
    const balloonPayment = this.terms?.RV ?? undefined;
    const assetCondition: AssetConditionValue = this.formControlStep2AssetCondition.value;
    const repayment = this.calculator?.emiAmt ?? undefined;
    const transactionType: TransactionValue = this.formControlStep2TransactionType.value;
    const privateSales: PrivateSaleType = transactionType ? (
      transactionType.type === 'Dealer Sale' ? 'No' :
      (transactionType.type === 'Private Sale' ? 'Yes' : transactionType.type)
      ) : 'No';
    const LoanPurpose: LoanPurposeValue = this.formControlStep2AssetPurpose.value;

    // file tags
    const otherSupportingDocs: UploadFileValue = this.formControlStep9OtherSupportingDocuments.value;
    const idDocumentUploads = [
      ...collectIndividualIdDocumentUploads(individualGarantors(guarantors)),
      ...(this.kybKeyPeopleComponent?.manualIdDocumentUploads() ?? []),
      ...(this.guarantorComponent?.manualIdDocumentUploads() ?? []),
    ];
    const allToBeDeleted = [...this.step9DeletedUploadedDocs].map(file => file.name);

    let allFiles: File[] = tagIndividualIdDocumentFiles(idDocumentUploads, otherIndividuals, this.step9OtherDocMetadata);
    if (otherSupportingDocs && otherSupportingDocs.length) {
      allFiles = [...allFiles, ...otherSupportingDocs];
    }

    allFiles = [...allFiles].filter(file => !allToBeDeleted.includes(file?.name));

    // get doc types
    let uploadedTags = allFiles.reduce((tags: string[], file) => [...tags, ...((file as any).tags ?? [])], []);
    uploadedTags = [...uploadedTags, ...this.step9UploadedDocs.reduce((tags: string[], file: AzureStorageDocument) => [...tags, ...Object.values(file?.tags ?? {})], [])];
    uploadedTags = [...new Set(uploadedTags)];
    console.log('=====uploadedTags: ', uploadedTags);
    for (const tag of uploadedTags) {
      if (!this.documentTypes.map(t => t.value).includes(tag)) {
        const tagObj = (Object.values(constants.documentTypes) as DocumentTag[]).find(obj => obj.value === tag);
        if (tagObj) {
          this.documentTypes.push(tagObj);
        }
      }
    }
    console.log('====updated defaultTags: ', this.documentTypes);

    const newCarAssetType = constants.NewCarsAssetTypeIndex;


    const companyDetails = (b && b.type === 'search-result' && b?.result) ?
      b.result :
      this.existingApplication?.CompanyDetails ? this.existingApplication.CompanyDetails : undefined;

    const correspondentDetails = c


    let apiBodyPricingDetails: SaveApplicationPricingDetailsData = {
      LoanTerm: loanTerm ?? undefined,
      InvoiceAmount: (invoiceAmount != null ? (invoiceAmount) : undefined),
      Deposit: (deposit != null ? (deposit) : undefined),
      Brokerage: brokerage ? numeral(brokerage.type).value() ?? undefined : undefined,
      BrokerageAmount: this.calculator?.brokerageAmount ?? 0,
      LoanAmount: loanAmount,
      PaymentPeriod: paymentPeriod ? paymentPeriod.name : undefined,
      DocFee: (docFee != null ? Number(docFee) : undefined) ,
      DocFeeFinanced: booleanToYesNo(docFeeFinanced),
      BrokerOriginationFee: brokerOriginationFee ?? undefined,
      PropertyOwner: booleanToYesNo(propertyOwner),
      AdverseOnFile: booleanToYesNo(adverseOnFile),
      EquifaxDirectorScoreThreshold: assetFinanceEquifaxDirectorScoreThreshold(
        this.formControlStep2EquifaxDirectorScoreAbove700.value,
        equifaxScore,
      ),
      PremiumDiscount: this.terms?.premiumDiscount ?? 0,
      Rate: rate,
      BalloonPaymentPercentage: balloonPercentage?.type ? Number(balloonPercentage.type) : undefined,
      BalloonPayment: balloonPayment,
      Repayment: repayment,
      BankStatementSubmitted: 'No' as const,
      PrivateSale: privateSales,
      AssetCondition: assetCondition?.type ?? undefined,
      TreasuryAssetCondition: getTreasuryAssetCondition(this.formControlStep2Asset.value?.year),
      AmountFinance: this.AmountFinance,
      TransactionType: transactionType ? transactionType.type : undefined,
      CreditRateAdjustment: 0, // when creating an application, creditRateAdjustment is 0
      LastUpdatedByUser: null, // when creating an application, lastUpdatedByUser is null
      RepaymentType: 'Advance'
    };

    const apiBodyReferences = [
      ...references
    ]
    const otherIndividual  = [
      ...otherIndividuals
    ];
    const apiBodyCommercialEntities = [
      primaryCommercialEntity,
      ...otherCommercialEntity,
    ];
  const contacts = contact;
  let apiBodyIndividuals =  otherIndividual.map(individual => ({
      ...individual,
      isPrimaryContact:
        individual.givenName === contacts?.firstName &&
        individual.surname === contacts?.lastName &&
        individual.email === contacts?.email,
    }));

    // The Individual Details step saves its edits straight to ApplicationIndividual, but every
    // draft save and the final submission rebuild this payload from the earlier step forms and
    // full-sync the parties - overlay the saved rows or those writes would revert them.
    if (savedIndividualDetails) {
      apiBodyIndividuals = mergeSavedIndividualsIntoInteflowIndividuals(apiBodyIndividuals, savedIndividualDetails.individuals);
    }

    const apiBodyContact = fromContactToInteflowContacts(contact);

    const apiBodyAppInfo = {
      BrokerAppID: this.brokerApplicationId ?? undefined,
      IntroducerGroup: introducerGroup,
      // Disclosed: disclosed,
      FinanceType: financeType?.name ?? undefined,
      // UserId: user!.UserId,
      // OriginatorBusinessId: user!.OriginatorBusinessId,
      UserEmail: user!.Email,
      UserFirstName: user!.GivenName,
      UserLastName: user!.FamilyName,
      Notes: applicationNotes ?? undefined,
      BusinessUse: booleanToYesNo(this.businessUseOnly),
      SelfServiceability:  booleanToYesNo(this.selfServiceability),
      BrokerflowDocumentID: brokerflowDocumentId ?? undefined,
      BrokerSalesforceID: brokerSalesforceId,
      BrokerAbn: brokerAbn,
      BrokerEntityName: brokerEntityName,
      AssetCategory: asset?.category?.index ?? undefined,
      AssetType: asset?.type?.index ?? undefined,
      ContactId: undefined,
      CustomerId: undefined,
      SalesforceId: undefined,
      StageName: 'Draft',
      isSwitchToEasyDoc : this.isSwitchToEasyDoc as any,
      productType: this.productType,
      LoanPurpose: LoanPurpose,
    };
    let apiBodyAssetSpec: UpdateApplicationData['AssetSpec'] = {
      make: asset?.make ?? undefined,
      family: asset?.family ?? undefined,
      year: asset?.year ?? undefined,
      vehicle: asset?.model ?? undefined,
      description: asset?.description ?? undefined,
      truckGrossVehicleWeight: asset?.truckGrossVehicleWeight ?? undefined,
      OtherCar: asset?.OtherCar ?? false,
      bodystyle: asset?.bodystyle ?? undefined,
    };

    // work out vehicle asset spec.
    let assetLvr = undefined;
    let vehSpec = {};
    if (asset?.category && asset?.type) {
      if ((isAssetVehicles(asset.category.index) && isAssetNewCars(asset.category.index, asset.type.index)) ||
        (isAssetTrucksOrTrailers(asset.category.index) && isAssetTypeLightOrHeavyTruck(asset.category.index, asset.type.index))) {
        if(this.terms) {
          assetLvr = this.terms.LVR;
          vehSpec = asset.vehicle ?? {};
        }
        apiBodyAssetSpec = {
          ...apiBodyAssetSpec,
          ...vehSpec,
          LVR: assetLvr ?? undefined,
        };
      }
    }

    // broker contact
    const brokerContact: SalesforceContactSameAccountSelectionValue = this.formControlStep1BrokerContact.value;

    const apiBody: WizardSubmitData = {
      ApplicationType: 'AssetFinance',
      IP: this.ip,
      ApplicantLocation: this.geoLocation,
      UserId: this.applicationService.getApplicationUserId(this.existingApplication,this.user),
      OriginatorBusinessId: this.applicationService.getApplicationOriginatorBusinessId(this.existingApplication,this.user),
      AppInfo: apiBodyAppInfo,
      AssetSpec: apiBodyAssetSpec,
      Contacts: apiBodyContact,
      // AZ-1475: both party arrays go over the wire in the API shape.
      parties: { individuals: apiBodyIndividuals, commercialEntities: apiBodyCommercialEntities },
      Reference: apiBodyReferences,
      PricingDetails: apiBodyPricingDetails,
      AcceptQuotation: this.acceptedQuotation,
      ApplicationNotes: applicationNotes ?? undefined,
      CompanyDetails: companyDetails ?? undefined,
      AdditionalBrokerCorrespondent: correspondentDetails ?? null,
      BrokerContact: brokerContact,
      //Documents: apiBodyDocuments,
      DocumentTypes: this.documentTypes,
      PreviousBusiness: previousBusiness,
    }
    console.log('====apibody: ', apiBody);

    return apiBody;
  }


  step5GuarantorEvent($event: GuarantorComponentEvent) {
    /// $event.entries
  }

  private step5OnwardsApplicantsThatAreGuarantor(): IndividualGuarantor[] {
    const applicant: TrusteeValue | MemberValue | PartnerValue | SoleTraderValue | DirectorValue = this.formControlStep4Applicant.value;
    const guarantors = applicantsThatAreGuarantor(applicant);
    return guarantors;
  }

  private step5OnwardsIndividualGuarantors(): IndividualGuarantor[] {
    const guarantors: GuarantorValue = this.formControlStep5Guarantors.value;
    return individualGarantors(guarantors);
  }

  calculateEstimation(date: Moment): TotalPaymentBreakupDialogData {
    const paymentFrequencyValue: PaymentFrequencyValue = this.formControlStep2PaymentFrequency.value;
    const assetConditionValue: AssetConditionValue = this.formControlStep2AssetCondition.value;
    const assetSelectionValue: AssetSelectionComponentValue = this.formControlStep2Asset.value;
    const loanTermValue: LoanTermsSelectionWithInputValue = this.formControlStep2LoanTerms.value;
    const financeTypeValue: FinanceTypeValue = this.formControlStep2FinanceType.value;
    const balloonPaymentValue: BalloonPaymentValue = this.formControlStep2BalloonPayment.value;
    const brokerageValue: BrokerageSelectionValue = this.formControlStep2Brokerage.value;
    const businessSearchValue = this.formControlStep1Business.value;
    const businessSearchValueWithSearchResult = businessSearchValue?.type == 'search-result' ? businessSearchValue : null;
    
    // Compute abnAgeAboveThresholdOverride based on Previous Business GST age (aligned with credit flow)
    const abnAgeAboveThresholdOverride = calculateAbnAgeOverrideFromPreviousBusiness(
      businessSearchValueWithSearchResult?.result?.ABNAgeMonths ?? 0,
      businessSearchValueWithSearchResult?.result?.GSTAgeMonths,
      this.formControlStep1PreviousBusiness.value
    );
    
    const rst = calculateAssetFinanceEstimation(date, {
      type: 'AssetFinance',
      paymentFrequencyType: paymentFrequencyValue?.type ?? null,
      assetConditionType: assetConditionValue?.type ?? null,
      assetSelectionValue: assetSelectionValue!,
      assetYear: parseFloat(assetSelectionValue?.year ?? '0'),
      loanTerm : numeral(loanTermValue).value() ?? 0,
      financeType: financeTypeValue?.type ?? null,
      loanAmount: numeral(this.formControlStep2LoanAmount.value).value() ?? 0,
      businessSearchValue: businessSearchValueWithSearchResult,
      existingApplicationBureauReport: this.existingApplicationBureauReport,
      propertyOwnership: this.formControlStep2PropertyOwner.value ?? false,
      docFeeFinanced: this.formControlStep2DocFeeFinanced.value ?? false,
      brokerOriginationFee: this.formControlStep2BrokerOriginationFee.value ?? 0,
      brokerage: Number(brokerageValue?.type ?? 0),
      adverseOnFile: this.formControlStep2AdverseOnFile.value ?? false,
      equifaxDirectorScoreMeetsProductThreshold: this.formControlStep2EquifaxScoreAboveThreshold.value ?? false,
      equifaxDirectorScoreAbove700: this.formControlStep2EquifaxDirectorScoreAbove700.value ?? false,
      privateSaleOrLeaseback: this.formControlStep2TransactionType.value?.type !== 'Dealer Sale',
      balloonPayment: numeral(balloonPaymentValue?.type).value() ?? 0,
      rateCard: this.rateCard,
      invoiceAmount: this.formControlStep2InvoiceAmount.value ?? 0,
      deposit: this.formControlStep2DepositAmount.value ?? 0,
      transactionType: this.formControlStep2TransactionType.value?.type,
      abnAgeAboveThresholdOverride,
    })
    console.log("calculateAssetFinanceEstimation rst", rst);
    this.calculator = rst.calculator;
    this.terms = rst.terms;
    this.step2Repayment = rst.repayment;

    this.AmountFinance = (rst.calculator.principalAmt + rst.calculator.brokerageAmount);

    return rst.totalPaymentBreakupDialogData;
  }

  private async step2ShowQuotation(stepper: CdkStepper) {
    this.step2EstimatedDrawdownDate = moment().add(1, 'day');

      this.step2Subscription1 = this.applicationDialogService.openAssetQuotationDialog({
        loadFn: (date) => {
          return this.calculateEstimation(date);
        },
        isQuote: false,
        paymentChartHideBalloonPayment: true,
        paymentChartHideBrokerOriginationFee: false,
        paymentChartHideBrokerage: false,
        showPaymentChart: true,
        showArmotizationChart: true,
        showRepaymentEstimation: true,
        showArmotisationSchedule: true,
      }).afterClosed()
        .pipe(
          tap(r => {
            if (r && r.acceptedQuotation) {
              this.acceptedQuotation = true;
              this.saveApplication(stepper, 2);
            }
          })
        ).subscribe();
  }

  private async saveApplication(stepper: CdkStepper, step: number) {
    if (!this.applicationId) { // application was not saved before (new draft)
      const inteflowData = await this.mapToInteflowData();
      console.log('save application (asset) inteflowData', inteflowData);
      this.applicationService.saveApplication(inteflowData).pipe(
        this.toastService.spinnerObservable(),
        tap(r => {
          console.log('save application (asset) log',r.payload.ApplicationId);
          const applicationId = r.payload.ApplicationId;
          const brokerApplicationId = r.payload.BrokerApplicationId;
          this.brokerApplicationId = brokerApplicationId;
          this.applicationId = applicationId;
          this.syncUrlWithApplicationId();
          const business: BusinessSearchValue = this.formControlStep1Business.value
          if (business) {
            this.organisationName = business.organisationName;
          }
          this.localApplicationDbService.addOrUpdateApplicationLocally(toDraftSimplifiedApplication(this.applicationId, inteflowData));
          stepper.next();
        }),
        catchError(err => {
          this.applicationDialogService.openAlertDialog({
            message: 'Error',
            subMessage: err?.error?.message ?? 'Unable to save application. Please try again.',
          });
          return of(null);
        })
      ).subscribe();
    } else {  // existing draft
      try {
        await this.updateDraftInBg(step);
        stepper.next();
      } catch (err: any) {
        this.applicationDialogService.openAlertDialog({
          message: 'Error',
          subMessage: err?.error?.message ?? 'Unable to save application. Please try again.',
        });
      }
    }
  }

  // Put the new draft's id in the address bar so a refresh reopens it instead of starting a blank
  // application. replaceState rather than router.navigate: 'asset-finance' and
  // 'asset-finance/:applicationId' are separate route configs, so navigating would rebuild this
  // component and discard everything the user has entered.
  private syncUrlWithApplicationId() {
    if (!this.applicationId) {
      return;
    }
    const urlTree = navigationUrlForAssetFinance(
      this.router,
      this.productType,
      this.isSwitchToEasyDoc,
      this.applicationId,
      this.queryParams,
    );
    this.location.replaceState(this.router.serializeUrl(urlTree));
  }

  // NOTE: not used anymore
  // private step2CalculateTotalBrokerageAmount(brokerOrigniationFee: number, brokerage: BrokerageSelectionValue): number {
  //   // todo: calculate total brokerage amount
  //   return 0; // not used currently
  // }

  // Steps that re-read parties can wait on the most recent draft save.
  private pendingDraftSave: Promise<void> = Promise.resolve();

  private async updateDraftInBg(step: number, fn?: ()=>void) {
    if (this.applicationId) {
      const data = await this.mapToInteflowData();
      // KYB "Key People" (step 4) rides on the same update-application2 request as the rest of the
      // parties so both saves share one transaction and cannot race/clobber role flags.
      if ((step === 4 || step === 5) && this.formControlStep4KybKeyPeople.value) {
        data.kybKeyPeople = mergeGuarantorKybSelections(this.formControlStep4KybKeyPeople.value, this.step5KybSelections);
      }
      this.localApplicationDbService.addOrUpdateApplicationLocally(toDraftSimplifiedApplication(this.applicationId, data));
      const save = this.applicationService.updateApplication(this.applicationId, data).pipe(
        tap(() => {
          if (fn) {
            fn();
          }
          // The entity and guarantor steps are what decide whether a deed is needed, so the trust
          // deed step's visibility is settled once their save has landed.
          if (step === 4 || step === 5 || step === 7) {
            this.refreshRequiredTrustDeeds();
          }
        })
      );
      // The Azure upload and SQL draft update are independent. Run them together, but keep one
      // loading lifecycle and require both acknowledgements before the step can advance.
      const saveOperation = from(Promise.allSettled([
        this.uploadFileToAzure(step, data),
        lastValueFrom(save),
      ])).pipe(
        fn
          ? this.toastService.loadingWithMessage(`Saving, please be patient`)
          : this.toastService.spinnerObservable(),
        map(results => {
          const failed = results.find(result => result.status === 'rejected');
          if (failed?.status === 'rejected') {
            throw failed.reason;
          }
        }),
      );
      const savePromise = lastValueFrom(saveOperation);
      this.pendingDraftSave = savePromise.then(() => undefined, () => undefined);
      await savePromise;
    }
  }

  onIdDocumentDelete(step: 4 | 5, document: UploadedDocumentRef) {
    const deleted = step === 4 ? this.step4DeletedIdDocuments : this.step5DeletedIdDocuments;
    if (!deleted.some(candidate => candidate.name === document.name)) {
      if (step === 4) {
        this.step4DeletedIdDocuments = [...deleted, document];
      } else {
        this.step5DeletedIdDocuments = [...deleted, document];
      }
    }
    this.applicationDocuments = this.applicationDocuments?.filter(candidate => candidate.name !== document.name) ?? null;
    this.step9UploadedDocs = this.step9UploadedDocs.filter(candidate => candidate.name !== document.name);
    this.filesUploadedToAzure = this.filesUploadedToAzure.filter(file => file.name !== document.metadata?.name);
  }


  onStep9DeleteUploadedDoc($event: UploadedFilesListComponentEvent) {
    this.filesUploadedToAzure = this.filesUploadedToAzure
      .filter(file => {
        return !(file.name === $event.deletedFile.metadata?.name);
      });
    this.step9DeletedUploadedDocs = [...$event.deleted];
  }

  get step9OtherDocMetadata() {
    const b: BusinessSearchValue = this.formControlStep1Business.value;
    const abn = this.formControlStep3Abn.value ?? '';
    const legalName = toInteflowLegalName(b) ?? '';

    return {
      abn: abn,
      legalname: legalName
    };
  }

  onStep9DocEvent(files: UploadAzureFiles) {
    if(files && files.length > 0) {
      this.formControlStep9OtherSupportingDocuments.setValue(files)
    } else {
      this.formControlStep9OtherSupportingDocuments.setValue(null)
    }
  }

  applicationDefaultDocuments(includeOptions = false): DocumentTag[] {
    const applicantsThatAreGuarantor: IndividualGuarantor[] = this.step5OnwardsApplicantsThatAreGuarantor();
    const guarantors: IndividualGuarantor[] = this.step5OnwardsIndividualGuarantors();
    const names = [...applicantsThatAreGuarantor, ...guarantors]
      .map(requireDriverLicence => `${requireDriverLicence.firstName} ${requireDriverLicence.lastName}`);
    return this.defaultDocuments(
      'AssetFinance',
      names,
      toInteflowLegalName(this.formControlStep1Business.value) ?? "",
      String((this.formControlStep2Asset.value as AssetSelectionComponentValue)?.category?.index),
      String((this.formControlStep2Asset.value as AssetSelectionComponentValue)?.type?.index),
      this.formControlStep2InvoiceAmount.value ?? 0,
      this.formControlStep2DepositAmount.value ?? 0,
      this.formControlStep2TransactionType.value?.type !== 'Dealer Sale',
      this.formControlStep3OrganisationType.value === EntityTypeTrustOption,
      this.formControlStep3OrganisationType.value === EntityTypePartnershipOption,
      includeOptions
    );
  }

  listUploadedDocuments() {
    if (this.applicationId) {
      this.subscriptions.push(
        this.applicationService.listApplicationDocumentFn(this.applicationId).subscribe(
          (r: AzureStorageDocument[]) => {
            // includes ID documents (driver licence / passport) uploaded through the individual form
            const documents = r.filter(arg => arg.metadata);
            this.step9UploadedDocs = documents;
            this.applicationDocuments = documents;
          }
        )
      )
    }
    }

}
